/*
 * 本文件由 `npm run gen:mavlink` 生成，请勿手工编辑。
 *
 * 上游定义快照见 packages/mavlink/definitions/（含固定提交 SHA）。
 * 共 326 条消息。字段顺序为**线上顺序**，不是 XML 书写顺序。
 */

import type { MessageDefinition } from '../types';

export const MESSAGES: readonly MessageDefinition[] = [
  {
    id: 0,
    name: "HEARTBEAT",
    crcExtra: 50,
    wireLength: 9,
    fields: [
      { name: "custom_mode", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_TYPE" },
      { name: "autopilot", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_AUTOPILOT" },
      { name: "base_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_MODE_FLAG" },
      { name: "system_status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_STATE" },
      { name: "mavlink_version", type: "uint8_t_mavlink_version", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 1,
    name: "SYS_STATUS",
    crcExtra: 124,
    wireLength: 43,
    fields: [
      { name: "onboard_control_sensors_present", type: "uint32_t", arrayLength: 0, extension: false, enumName: "MAV_SYS_STATUS_SENSOR", printFormat: "0x%04x" },
      { name: "onboard_control_sensors_enabled", type: "uint32_t", arrayLength: 0, extension: false, enumName: "MAV_SYS_STATUS_SENSOR", printFormat: "0x%04x" },
      { name: "onboard_control_sensors_health", type: "uint32_t", arrayLength: 0, extension: false, enumName: "MAV_SYS_STATUS_SENSOR", printFormat: "0x%04x" },
      { name: "load", type: "uint16_t", arrayLength: 0, extension: false, units: "d%" },
      { name: "voltage_battery", type: "uint16_t", arrayLength: 0, extension: false, units: "mV", invalid: "UINT16_MAX" },
      { name: "current_battery", type: "int16_t", arrayLength: 0, extension: false, units: "cA", invalid: "-1" },
      { name: "drop_rate_comm", type: "uint16_t", arrayLength: 0, extension: false, units: "c%" },
      { name: "errors_comm", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "errors_count1", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "errors_count2", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "errors_count3", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "errors_count4", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "battery_remaining", type: "int8_t", arrayLength: 0, extension: false, units: "%", invalid: "-1" },
      { name: "onboard_control_sensors_present_extended", type: "uint32_t", arrayLength: 0, extension: true, enumName: "MAV_SYS_STATUS_SENSOR_EXTENDED", printFormat: "0x%04x" },
      { name: "onboard_control_sensors_enabled_extended", type: "uint32_t", arrayLength: 0, extension: true, enumName: "MAV_SYS_STATUS_SENSOR_EXTENDED", printFormat: "0x%04x" },
      { name: "onboard_control_sensors_health_extended", type: "uint32_t", arrayLength: 0, extension: true, enumName: "MAV_SYS_STATUS_SENSOR_EXTENDED", printFormat: "0x%04x" },
    ],
  },
  {
    id: 2,
    name: "SYSTEM_TIME",
    crcExtra: 137,
    wireLength: 12,
    fields: [
      { name: "time_unix_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
    ],
  },
  {
    id: 4,
    name: "PING",
    crcExtra: 237,
    wireLength: 14,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "seq", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 5,
    name: "CHANGE_OPERATOR_CONTROL",
    crcExtra: 217,
    wireLength: 28,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "control_request", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "version", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "passkey", type: "char", arrayLength: 25, extension: false },
    ],
  },
  {
    id: 6,
    name: "CHANGE_OPERATOR_CONTROL_ACK",
    crcExtra: 104,
    wireLength: 3,
    fields: [
      { name: "gcs_system_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "control_request", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "ack", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 7,
    name: "AUTH_KEY",
    crcExtra: 119,
    wireLength: 32,
    fields: [
      { name: "key", type: "char", arrayLength: 32, extension: false },
    ],
  },
  {
    id: 8,
    name: "LINK_NODE_STATUS",
    crcExtra: 117,
    wireLength: 36,
    fields: [
      { name: "timestamp", type: "uint64_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "tx_rate", type: "uint32_t", arrayLength: 0, extension: false, units: "bytes/s" },
      { name: "rx_rate", type: "uint32_t", arrayLength: 0, extension: false, units: "bytes/s" },
      { name: "messages_sent", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "messages_received", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "messages_lost", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "rx_parse_err", type: "uint16_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "tx_overflows", type: "uint16_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "rx_overflows", type: "uint16_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "tx_buf", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
      { name: "rx_buf", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
    ],
  },
  {
    id: 11,
    name: "SET_MODE",
    crcExtra: 89,
    wireLength: 6,
    fields: [
      { name: "custom_mode", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "base_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_MODE_FLAG" },
    ],
  },
  {
    id: 20,
    name: "PARAM_REQUEST_READ",
    crcExtra: 214,
    wireLength: 20,
    fields: [
      { name: "param_index", type: "int16_t", arrayLength: 0, extension: false, invalid: "-1" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
    ],
  },
  {
    id: 21,
    name: "PARAM_REQUEST_LIST",
    crcExtra: 159,
    wireLength: 2,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 22,
    name: "PARAM_VALUE",
    crcExtra: 220,
    wireLength: 25,
    fields: [
      { name: "param_value", type: "float", arrayLength: 0, extension: false },
      { name: "param_count", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "param_index", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "param_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_PARAM_TYPE" },
    ],
  },
  {
    id: 23,
    name: "PARAM_SET",
    crcExtra: 168,
    wireLength: 23,
    fields: [
      { name: "param_value", type: "float", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "param_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_PARAM_TYPE" },
    ],
  },
  {
    id: 24,
    name: "GPS_RAW_INT",
    crcExtra: 24,
    wireLength: 52,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "eph", type: "uint16_t", arrayLength: 0, extension: false, multiplier: "1E-2", invalid: "UINT16_MAX" },
      { name: "epv", type: "uint16_t", arrayLength: 0, extension: false, multiplier: "1E-2", invalid: "UINT16_MAX" },
      { name: "vel", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s", invalid: "UINT16_MAX" },
      { name: "cog", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "UINT16_MAX" },
      { name: "fix_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GPS_FIX_TYPE" },
      { name: "satellites_visible", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "alt_ellipsoid", type: "int32_t", arrayLength: 0, extension: true, units: "mm" },
      { name: "h_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "mm" },
      { name: "v_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "mm" },
      { name: "vel_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "mm/s" },
      { name: "hdg_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "degE5" },
      { name: "yaw", type: "uint16_t", arrayLength: 0, extension: true, units: "cdeg", invalid: "0" },
    ],
  },
  {
    id: 25,
    name: "GPS_STATUS",
    crcExtra: 23,
    wireLength: 101,
    fields: [
      { name: "satellites_visible", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "satellite_prn", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "satellite_used", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "satellite_elevation", type: "uint8_t", arrayLength: 20, extension: false, units: "deg" },
      { name: "satellite_azimuth", type: "uint8_t", arrayLength: 20, extension: false, units: "deg", multiplier: "360/255" },
      { name: "satellite_snr", type: "uint8_t", arrayLength: 20, extension: false, units: "dB" },
    ],
  },
  {
    id: 26,
    name: "SCALED_IMU",
    crcExtra: 170,
    wireLength: 24,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "xacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "yacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "zacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "xgyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "ygyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "zgyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "xmag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "ymag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "zmag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: true, units: "cdegC" },
    ],
  },
  {
    id: 27,
    name: "RAW_IMU",
    crcExtra: 144,
    wireLength: 29,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "xacc", type: "int16_t", arrayLength: 0, extension: false },
      { name: "yacc", type: "int16_t", arrayLength: 0, extension: false },
      { name: "zacc", type: "int16_t", arrayLength: 0, extension: false },
      { name: "xgyro", type: "int16_t", arrayLength: 0, extension: false },
      { name: "ygyro", type: "int16_t", arrayLength: 0, extension: false },
      { name: "zgyro", type: "int16_t", arrayLength: 0, extension: false },
      { name: "xmag", type: "int16_t", arrayLength: 0, extension: false },
      { name: "ymag", type: "int16_t", arrayLength: 0, extension: false },
      { name: "zmag", type: "int16_t", arrayLength: 0, extension: false },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: true },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: true, units: "cdegC" },
    ],
  },
  {
    id: 28,
    name: "RAW_PRESSURE",
    crcExtra: 67,
    wireLength: 16,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "press_abs", type: "int16_t", arrayLength: 0, extension: false },
      { name: "press_diff1", type: "int16_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "press_diff2", type: "int16_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 29,
    name: "SCALED_PRESSURE",
    crcExtra: 115,
    wireLength: 16,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "press_abs", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "press_diff", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC" },
      { name: "temperature_press_diff", type: "int16_t", arrayLength: 0, extension: true, units: "cdegC", invalid: "0" },
    ],
  },
  {
    id: 30,
    name: "ATTITUDE",
    crcExtra: 39,
    wireLength: 28,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "rollspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitchspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yawspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
    ],
  },
  {
    id: 31,
    name: "ATTITUDE_QUATERNION",
    crcExtra: 246,
    wireLength: 48,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "q1", type: "float", arrayLength: 0, extension: false },
      { name: "q2", type: "float", arrayLength: 0, extension: false },
      { name: "q3", type: "float", arrayLength: 0, extension: false },
      { name: "q4", type: "float", arrayLength: 0, extension: false },
      { name: "rollspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitchspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yawspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "repr_offset_q", type: "float", arrayLength: 4, extension: true, invalid: "[0]" },
    ],
  },
  {
    id: 32,
    name: "LOCAL_POSITION_NED",
    crcExtra: 185,
    wireLength: 28,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
    ],
  },
  {
    id: 33,
    name: "GLOBAL_POSITION_INT",
    crcExtra: 104,
    wireLength: 28,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "relative_alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "vx", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vy", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vz", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "hdg", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "UINT16_MAX" },
    ],
  },
  {
    id: 34,
    name: "RC_CHANNELS_SCALED",
    crcExtra: 237,
    wireLength: 22,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "chan1_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "chan2_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "chan3_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "chan4_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "chan5_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "chan6_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "chan7_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "chan8_scaled", type: "int16_t", arrayLength: 0, extension: false, invalid: "INT16_MAX" },
      { name: "port", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rssi", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
    ],
  },
  {
    id: 35,
    name: "RC_CHANNELS_RAW",
    crcExtra: 244,
    wireLength: 22,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "chan1_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan2_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan3_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan4_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan5_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan6_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan7_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan8_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "port", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rssi", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
    ],
  },
  {
    id: 36,
    name: "SERVO_OUTPUT_RAW",
    crcExtra: 222,
    wireLength: 37,
    fields: [
      { name: "time_usec", type: "uint32_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo1_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo2_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo3_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo4_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo5_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo6_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo7_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "servo8_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "port", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "servo9_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
      { name: "servo10_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
      { name: "servo11_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
      { name: "servo12_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
      { name: "servo13_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
      { name: "servo14_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
      { name: "servo15_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
      { name: "servo16_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us" },
    ],
  },
  {
    id: 37,
    name: "MISSION_REQUEST_PARTIAL_LIST",
    crcExtra: 212,
    wireLength: 7,
    fields: [
      { name: "start_index", type: "int16_t", arrayLength: 0, extension: false },
      { name: "end_index", type: "int16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 38,
    name: "MISSION_WRITE_PARTIAL_LIST",
    crcExtra: 9,
    wireLength: 7,
    fields: [
      { name: "start_index", type: "int16_t", arrayLength: 0, extension: false },
      { name: "end_index", type: "int16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 39,
    name: "MISSION_ITEM",
    crcExtra: 254,
    wireLength: 38,
    fields: [
      { name: "param1", type: "float", arrayLength: 0, extension: false },
      { name: "param2", type: "float", arrayLength: 0, extension: false },
      { name: "param3", type: "float", arrayLength: 0, extension: false },
      { name: "param4", type: "float", arrayLength: 0, extension: false },
      { name: "x", type: "float", arrayLength: 0, extension: false },
      { name: "y", type: "float", arrayLength: 0, extension: false },
      { name: "z", type: "float", arrayLength: 0, extension: false },
      { name: "seq", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "command", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_CMD" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
      { name: "current", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "autocontinue", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 40,
    name: "MISSION_REQUEST",
    crcExtra: 230,
    wireLength: 5,
    fields: [
      { name: "seq", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 41,
    name: "MISSION_SET_CURRENT",
    crcExtra: 28,
    wireLength: 4,
    fields: [
      { name: "seq", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 42,
    name: "MISSION_CURRENT",
    crcExtra: 28,
    wireLength: 18,
    fields: [
      { name: "seq", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "total", type: "uint16_t", arrayLength: 0, extension: true, invalid: "UINT16_MAX" },
      { name: "mission_state", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MISSION_STATE", invalid: "0" },
      { name: "mission_mode", type: "uint8_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "mission_id", type: "uint32_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "fence_id", type: "uint32_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "rally_points_id", type: "uint32_t", arrayLength: 0, extension: true, invalid: "0" },
    ],
  },
  {
    id: 43,
    name: "MISSION_REQUEST_LIST",
    crcExtra: 132,
    wireLength: 3,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 44,
    name: "MISSION_COUNT",
    crcExtra: 221,
    wireLength: 9,
    fields: [
      { name: "count", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
      { name: "opaque_id", type: "uint32_t", arrayLength: 0, extension: true, invalid: "0" },
    ],
  },
  {
    id: 45,
    name: "MISSION_CLEAR_ALL",
    crcExtra: 232,
    wireLength: 3,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 46,
    name: "MISSION_ITEM_REACHED",
    crcExtra: 11,
    wireLength: 2,
    fields: [
      { name: "seq", type: "uint16_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 47,
    name: "MISSION_ACK",
    crcExtra: 153,
    wireLength: 8,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_MISSION_RESULT" },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
      { name: "opaque_id", type: "uint32_t", arrayLength: 0, extension: true, invalid: "0" },
    ],
  },
  {
    id: 48,
    name: "SET_GPS_GLOBAL_ORIGIN",
    crcExtra: 41,
    wireLength: 21,
    fields: [
      { name: "latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "altitude", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: true, units: "us" },
    ],
  },
  {
    id: 49,
    name: "GPS_GLOBAL_ORIGIN",
    crcExtra: 39,
    wireLength: 20,
    fields: [
      { name: "latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "altitude", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: true, units: "us" },
    ],
  },
  {
    id: 50,
    name: "PARAM_MAP_RC",
    crcExtra: 78,
    wireLength: 37,
    fields: [
      { name: "param_value0", type: "float", arrayLength: 0, extension: false },
      { name: "scale", type: "float", arrayLength: 0, extension: false },
      { name: "param_value_min", type: "float", arrayLength: 0, extension: false },
      { name: "param_value_max", type: "float", arrayLength: 0, extension: false },
      { name: "param_index", type: "int16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "parameter_rc_channel_index", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 51,
    name: "MISSION_REQUEST_INT",
    crcExtra: 196,
    wireLength: 5,
    fields: [
      { name: "seq", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 54,
    name: "SAFETY_SET_ALLOWED_AREA",
    crcExtra: 15,
    wireLength: 27,
    fields: [
      { name: "p1x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p1y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p1z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p2x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p2y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p2z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 55,
    name: "SAFETY_ALLOWED_AREA",
    crcExtra: 3,
    wireLength: 25,
    fields: [
      { name: "p1x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p1y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p1z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p2x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p2y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "p2z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 61,
    name: "ATTITUDE_QUATERNION_COV",
    crcExtra: 167,
    wireLength: 72,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "rollspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitchspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yawspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "covariance", type: "float", arrayLength: 9, extension: false, invalid: "[NaN:]" },
    ],
  },
  {
    id: 62,
    name: "NAV_CONTROLLER_OUTPUT",
    crcExtra: 183,
    wireLength: 26,
    fields: [
      { name: "nav_roll", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "nav_pitch", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "alt_error", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "aspd_error", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "xtrack_error", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "nav_bearing", type: "int16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "target_bearing", type: "int16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "wp_dist", type: "uint16_t", arrayLength: 0, extension: false, units: "m" },
    ],
  },
  {
    id: 63,
    name: "GLOBAL_POSITION_INT_COV",
    crcExtra: 119,
    wireLength: 181,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "relative_alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "covariance", type: "float", arrayLength: 36, extension: false, invalid: "[NaN:]" },
      { name: "estimator_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ESTIMATOR_TYPE" },
    ],
  },
  {
    id: 64,
    name: "LOCAL_POSITION_NED_COV",
    crcExtra: 191,
    wireLength: 225,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "ax", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "ay", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "az", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "covariance", type: "float", arrayLength: 45, extension: false, invalid: "[NaN:]" },
      { name: "estimator_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ESTIMATOR_TYPE" },
    ],
  },
  {
    id: 65,
    name: "RC_CHANNELS",
    crcExtra: 118,
    wireLength: 42,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "chan1_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan2_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan3_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan4_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan5_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan6_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan7_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan8_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan9_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan10_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan11_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan12_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan13_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan14_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan15_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan16_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan17_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan18_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chancount", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rssi", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
    ],
  },
  {
    id: 66,
    name: "REQUEST_DATA_STREAM",
    crcExtra: 148,
    wireLength: 6,
    fields: [
      { name: "req_message_rate", type: "uint16_t", arrayLength: 0, extension: false, units: "Hz" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "req_stream_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_DATA_STREAM" },
      { name: "start_stop", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 67,
    name: "DATA_STREAM",
    crcExtra: 21,
    wireLength: 4,
    fields: [
      { name: "message_rate", type: "uint16_t", arrayLength: 0, extension: false, units: "Hz" },
      { name: "stream_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_DATA_STREAM" },
      { name: "on_off", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 69,
    name: "MANUAL_CONTROL",
    crcExtra: 243,
    wireLength: 30,
    fields: [
      { name: "x", type: "int16_t", arrayLength: 0, extension: false, minValue: "-1000", maxValue: "1000", invalid: "INT16_MAX" },
      { name: "y", type: "int16_t", arrayLength: 0, extension: false, minValue: "-1000", maxValue: "1000", invalid: "INT16_MAX" },
      { name: "z", type: "int16_t", arrayLength: 0, extension: false, minValue: "-1000", maxValue: "1000", invalid: "INT16_MAX" },
      { name: "r", type: "int16_t", arrayLength: 0, extension: false, minValue: "-1000", maxValue: "1000", invalid: "INT16_MAX" },
      { name: "buttons", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "buttons2", type: "uint16_t", arrayLength: 0, extension: true },
      { name: "enabled_extensions", type: "uint8_t", arrayLength: 0, extension: true },
      { name: "s", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
      { name: "t", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
      { name: "aux1", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
      { name: "aux2", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
      { name: "aux3", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
      { name: "aux4", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
      { name: "aux5", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
      { name: "aux6", type: "int16_t", arrayLength: 0, extension: true, minValue: "-1000", maxValue: "1000" },
    ],
  },
  {
    id: 70,
    name: "RC_CHANNELS_OVERRIDE",
    crcExtra: 124,
    wireLength: 38,
    fields: [
      { name: "chan1_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan2_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan3_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan4_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan5_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan6_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan7_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "chan8_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us", invalid: "UINT16_MAX" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "chan9_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan10_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan11_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan12_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan13_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan14_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan15_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan16_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan17_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
      { name: "chan18_raw", type: "uint16_t", arrayLength: 0, extension: true, units: "us", invalid: "0" },
    ],
  },
  {
    id: 73,
    name: "MISSION_ITEM_INT",
    crcExtra: 38,
    wireLength: 38,
    fields: [
      { name: "param1", type: "float", arrayLength: 0, extension: false },
      { name: "param2", type: "float", arrayLength: 0, extension: false },
      { name: "param3", type: "float", arrayLength: 0, extension: false },
      { name: "param4", type: "float", arrayLength: 0, extension: false },
      { name: "x", type: "int32_t", arrayLength: 0, extension: false },
      { name: "y", type: "int32_t", arrayLength: 0, extension: false },
      { name: "z", type: "float", arrayLength: 0, extension: false },
      { name: "seq", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "command", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_CMD" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
      { name: "current", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "autocontinue", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mission_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MISSION_TYPE" },
    ],
  },
  {
    id: 74,
    name: "VFR_HUD",
    crcExtra: 20,
    wireLength: 20,
    fields: [
      { name: "airspeed", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "groundspeed", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "climb", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "heading", type: "int16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "throttle", type: "uint16_t", arrayLength: 0, extension: false, units: "%" },
    ],
  },
  {
    id: 75,
    name: "COMMAND_INT",
    crcExtra: 158,
    wireLength: 35,
    fields: [
      { name: "param1", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param2", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param3", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param4", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "x", type: "int32_t", arrayLength: 0, extension: false, invalid: "INT32_MAX" },
      { name: "y", type: "int32_t", arrayLength: 0, extension: false, invalid: "INT32_MAX" },
      { name: "z", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "command", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_CMD" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
      { name: "current", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "autocontinue", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 76,
    name: "COMMAND_LONG",
    crcExtra: 152,
    wireLength: 33,
    fields: [
      { name: "param1", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param2", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param3", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param4", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param5", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param6", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "param7", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "command", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_CMD" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "confirmation", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 77,
    name: "COMMAND_ACK",
    crcExtra: 143,
    wireLength: 10,
    fields: [
      { name: "command", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_CMD" },
      { name: "result", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_RESULT" },
      { name: "progress", type: "uint8_t", arrayLength: 0, extension: true, units: "%", invalid: "UINT8_MAX" },
      { name: "result_param2", type: "int32_t", arrayLength: 0, extension: true },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: true },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 80,
    name: "COMMAND_CANCEL",
    crcExtra: 14,
    wireLength: 4,
    fields: [
      { name: "command", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_CMD" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 81,
    name: "MANUAL_SETPOINT",
    crcExtra: 106,
    wireLength: 22,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "thrust", type: "float", arrayLength: 0, extension: false },
      { name: "mode_switch", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "manual_override_switch", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 82,
    name: "SET_ATTITUDE_TARGET",
    crcExtra: 49,
    wireLength: 51,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "body_roll_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "body_pitch_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "body_yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "thrust", type: "float", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "type_mask", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ATTITUDE_TARGET_TYPEMASK" },
      { name: "thrust_body", type: "float", arrayLength: 3, extension: true },
    ],
  },
  {
    id: 83,
    name: "ATTITUDE_TARGET",
    crcExtra: 22,
    wireLength: 37,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "body_roll_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "body_pitch_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "body_yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "thrust", type: "float", arrayLength: 0, extension: false },
      { name: "type_mask", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ATTITUDE_TARGET_TYPEMASK" },
    ],
  },
  {
    id: 84,
    name: "SET_POSITION_TARGET_LOCAL_NED",
    crcExtra: 143,
    wireLength: 53,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "afx", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afy", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afz", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "type_mask", type: "uint16_t", arrayLength: 0, extension: false, enumName: "POSITION_TARGET_TYPEMASK" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "coordinate_frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 85,
    name: "POSITION_TARGET_LOCAL_NED",
    crcExtra: 140,
    wireLength: 51,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "afx", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afy", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afz", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "type_mask", type: "uint16_t", arrayLength: 0, extension: false, enumName: "POSITION_TARGET_TYPEMASK" },
      { name: "coordinate_frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 86,
    name: "SET_POSITION_TARGET_GLOBAL_INT",
    crcExtra: 5,
    wireLength: 53,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "lat_int", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon_int", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "afx", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afy", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afz", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "type_mask", type: "uint16_t", arrayLength: 0, extension: false, enumName: "POSITION_TARGET_TYPEMASK" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "coordinate_frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 87,
    name: "POSITION_TARGET_GLOBAL_INT",
    crcExtra: 150,
    wireLength: 51,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "lat_int", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon_int", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "afx", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afy", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "afz", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "type_mask", type: "uint16_t", arrayLength: 0, extension: false, enumName: "POSITION_TARGET_TYPEMASK" },
      { name: "coordinate_frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 89,
    name: "LOCAL_POSITION_NED_SYSTEM_GLOBAL_OFFSET",
    crcExtra: 231,
    wireLength: 28,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
    ],
  },
  {
    id: 90,
    name: "HIL_STATE",
    crcExtra: 183,
    wireLength: 56,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "rollspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitchspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yawspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "vx", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vy", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vz", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "xacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "yacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "zacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
    ],
  },
  {
    id: 91,
    name: "HIL_CONTROLS",
    crcExtra: 63,
    wireLength: 42,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "roll_ailerons", type: "float", arrayLength: 0, extension: false },
      { name: "pitch_elevator", type: "float", arrayLength: 0, extension: false },
      { name: "yaw_rudder", type: "float", arrayLength: 0, extension: false },
      { name: "throttle", type: "float", arrayLength: 0, extension: false },
      { name: "aux1", type: "float", arrayLength: 0, extension: false },
      { name: "aux2", type: "float", arrayLength: 0, extension: false },
      { name: "aux3", type: "float", arrayLength: 0, extension: false },
      { name: "aux4", type: "float", arrayLength: 0, extension: false },
      { name: "mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_MODE" },
      { name: "nav_mode", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 92,
    name: "HIL_RC_INPUTS_RAW",
    crcExtra: 54,
    wireLength: 33,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan1_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan2_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan3_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan4_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan5_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan6_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan7_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan8_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan9_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan10_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan11_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "chan12_raw", type: "uint16_t", arrayLength: 0, extension: false, units: "us" },
      { name: "rssi", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
    ],
  },
  {
    id: 93,
    name: "HIL_ACTUATOR_CONTROLS",
    crcExtra: 47,
    wireLength: 81,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "flags", type: "uint64_t", arrayLength: 0, extension: false, enumName: "HIL_ACTUATOR_CONTROLS_FLAGS" },
      { name: "controls", type: "float", arrayLength: 16, extension: false },
      { name: "mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_MODE_FLAG" },
    ],
  },
  {
    id: 100,
    name: "OPTICAL_FLOW",
    crcExtra: 175,
    wireLength: 34,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "flow_comp_m_x", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "flow_comp_m_y", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "ground_distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "flow_x", type: "int16_t", arrayLength: 0, extension: false, units: "dpix" },
      { name: "flow_y", type: "int16_t", arrayLength: 0, extension: false, units: "dpix" },
      { name: "sensor_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "quality", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "flow_rate_x", type: "float", arrayLength: 0, extension: true, units: "rad/s" },
      { name: "flow_rate_y", type: "float", arrayLength: 0, extension: true, units: "rad/s" },
    ],
  },
  {
    id: 101,
    name: "GLOBAL_VISION_POSITION_ESTIMATE",
    crcExtra: 102,
    wireLength: 117,
    fields: [
      { name: "usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "covariance", type: "float", arrayLength: 21, extension: true, invalid: "[NaN:]" },
      { name: "reset_counter", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 102,
    name: "VISION_POSITION_ESTIMATE",
    crcExtra: 158,
    wireLength: 117,
    fields: [
      { name: "usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "covariance", type: "float", arrayLength: 21, extension: true, invalid: "[NaN:]" },
      { name: "reset_counter", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 103,
    name: "VISION_SPEED_ESTIMATE",
    crcExtra: 208,
    wireLength: 57,
    fields: [
      { name: "usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "covariance", type: "float", arrayLength: 9, extension: true, invalid: "[NaN:]" },
      { name: "reset_counter", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 104,
    name: "VICON_POSITION_ESTIMATE",
    crcExtra: 56,
    wireLength: 116,
    fields: [
      { name: "usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "covariance", type: "float", arrayLength: 21, extension: true, invalid: "[NaN:]" },
    ],
  },
  {
    id: 105,
    name: "HIGHRES_IMU",
    crcExtra: 93,
    wireLength: 63,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "xacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "zacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "xgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "ygyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "zgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "xmag", type: "float", arrayLength: 0, extension: false, units: "gauss" },
      { name: "ymag", type: "float", arrayLength: 0, extension: false, units: "gauss" },
      { name: "zmag", type: "float", arrayLength: 0, extension: false, units: "gauss" },
      { name: "abs_pressure", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "diff_pressure", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "pressure_alt", type: "float", arrayLength: 0, extension: false },
      { name: "temperature", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "fields_updated", type: "uint16_t", arrayLength: 0, extension: false, enumName: "HIGHRES_IMU_UPDATED_FLAGS" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 106,
    name: "OPTICAL_FLOW_RAD",
    crcExtra: 138,
    wireLength: 44,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "integration_time_us", type: "uint32_t", arrayLength: 0, extension: false, units: "us" },
      { name: "integrated_x", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_y", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_xgyro", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_ygyro", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_zgyro", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "time_delta_distance_us", type: "uint32_t", arrayLength: 0, extension: false, units: "us" },
      { name: "distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC" },
      { name: "sensor_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "quality", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 107,
    name: "HIL_SENSOR",
    crcExtra: 108,
    wireLength: 65,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "xacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "zacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "xgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "ygyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "zgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "xmag", type: "float", arrayLength: 0, extension: false, units: "gauss" },
      { name: "ymag", type: "float", arrayLength: 0, extension: false, units: "gauss" },
      { name: "zmag", type: "float", arrayLength: 0, extension: false, units: "gauss" },
      { name: "abs_pressure", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "diff_pressure", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "pressure_alt", type: "float", arrayLength: 0, extension: false },
      { name: "temperature", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "fields_updated", type: "uint32_t", arrayLength: 0, extension: false, enumName: "HIL_SENSOR_UPDATED_FLAGS" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 108,
    name: "SIM_STATE",
    crcExtra: 32,
    wireLength: 92,
    fields: [
      { name: "q1", type: "float", arrayLength: 0, extension: false },
      { name: "q2", type: "float", arrayLength: 0, extension: false },
      { name: "q3", type: "float", arrayLength: 0, extension: false },
      { name: "q4", type: "float", arrayLength: 0, extension: false },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "xacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "zacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "xgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "ygyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "zgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "lat", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "lon", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "std_dev_horz", type: "float", arrayLength: 0, extension: false },
      { name: "std_dev_vert", type: "float", arrayLength: 0, extension: false },
      { name: "vn", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "ve", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vd", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "lat_int", type: "int32_t", arrayLength: 0, extension: true, units: "degE7", invalid: "0" },
      { name: "lon_int", type: "int32_t", arrayLength: 0, extension: true, units: "degE7", invalid: "0" },
    ],
  },
  {
    id: 109,
    name: "RADIO_STATUS",
    crcExtra: 185,
    wireLength: 9,
    fields: [
      { name: "rxerrors", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "fixed", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "rssi", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "remrssi", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "txbuf", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
      { name: "noise", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "remnoise", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
    ],
  },
  {
    id: 110,
    name: "FILE_TRANSFER_PROTOCOL",
    crcExtra: 84,
    wireLength: 254,
    fields: [
      { name: "target_network", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "payload", type: "uint8_t", arrayLength: 251, extension: false },
    ],
  },
  {
    id: 111,
    name: "TIMESYNC",
    crcExtra: 34,
    wireLength: 18,
    fields: [
      { name: "tc1", type: "int64_t", arrayLength: 0, extension: false, units: "ns" },
      { name: "ts1", type: "int64_t", arrayLength: 0, extension: false, units: "ns" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: true },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 112,
    name: "CAMERA_TRIGGER",
    crcExtra: 174,
    wireLength: 12,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "seq", type: "uint32_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 113,
    name: "HIL_GPS",
    crcExtra: 124,
    wireLength: 39,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "eph", type: "uint16_t", arrayLength: 0, extension: false, multiplier: "1E-2", invalid: "UINT16_MAX" },
      { name: "epv", type: "uint16_t", arrayLength: 0, extension: false, multiplier: "1E-2", invalid: "UINT16_MAX" },
      { name: "vel", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s", invalid: "UINT16_MAX" },
      { name: "vn", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "ve", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vd", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "cog", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "UINT16_MAX" },
      { name: "fix_type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "satellites_visible", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: true },
      { name: "yaw", type: "uint16_t", arrayLength: 0, extension: true, units: "cdeg" },
    ],
  },
  {
    id: 114,
    name: "HIL_OPTICAL_FLOW",
    crcExtra: 237,
    wireLength: 44,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "integration_time_us", type: "uint32_t", arrayLength: 0, extension: false, units: "us" },
      { name: "integrated_x", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_y", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_xgyro", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_ygyro", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "integrated_zgyro", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "time_delta_distance_us", type: "uint32_t", arrayLength: 0, extension: false, units: "us" },
      { name: "distance", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1.0" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC" },
      { name: "sensor_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "quality", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 115,
    name: "HIL_STATE_QUATERNION",
    crcExtra: 4,
    wireLength: 64,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "attitude_quaternion", type: "float", arrayLength: 4, extension: false },
      { name: "rollspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitchspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yawspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "vx", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vy", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vz", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "ind_airspeed", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "true_airspeed", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "xacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "yacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "zacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
    ],
  },
  {
    id: 116,
    name: "SCALED_IMU2",
    crcExtra: 76,
    wireLength: 24,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "xacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "yacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "zacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "xgyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "ygyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "zgyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "xmag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "ymag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "zmag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: true, units: "cdegC", invalid: "0" },
    ],
  },
  {
    id: 117,
    name: "LOG_REQUEST_LIST",
    crcExtra: 128,
    wireLength: 6,
    fields: [
      { name: "start", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "end", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 118,
    name: "LOG_ENTRY",
    crcExtra: 56,
    wireLength: 14,
    fields: [
      { name: "time_utc", type: "uint32_t", arrayLength: 0, extension: false, units: "s", invalid: "0" },
      { name: "size", type: "uint32_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "id", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "num_logs", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "last_log_num", type: "uint16_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 119,
    name: "LOG_REQUEST_DATA",
    crcExtra: 116,
    wireLength: 12,
    fields: [
      { name: "ofs", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint32_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "id", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 120,
    name: "LOG_DATA",
    crcExtra: 134,
    wireLength: 97,
    fields: [
      { name: "ofs", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "id", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 90, extension: false },
    ],
  },
  {
    id: 121,
    name: "LOG_ERASE",
    crcExtra: 237,
    wireLength: 2,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 122,
    name: "LOG_REQUEST_END",
    crcExtra: 203,
    wireLength: 2,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 123,
    name: "GPS_INJECT_DATA",
    crcExtra: 250,
    wireLength: 113,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 110, extension: false },
    ],
  },
  {
    id: 124,
    name: "GPS2_RAW",
    crcExtra: 87,
    wireLength: 57,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "dgps_age", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "eph", type: "uint16_t", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "epv", type: "uint16_t", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "vel", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s", invalid: "UINT16_MAX" },
      { name: "cog", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "UINT16_MAX" },
      { name: "fix_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GPS_FIX_TYPE" },
      { name: "satellites_visible", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "dgps_numch", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "yaw", type: "uint16_t", arrayLength: 0, extension: true, units: "cdeg", invalid: "0" },
      { name: "alt_ellipsoid", type: "int32_t", arrayLength: 0, extension: true, units: "mm" },
      { name: "h_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "mm" },
      { name: "v_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "mm" },
      { name: "vel_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "mm/s" },
      { name: "hdg_acc", type: "uint32_t", arrayLength: 0, extension: true, units: "degE5" },
    ],
  },
  {
    id: 125,
    name: "POWER_STATUS",
    crcExtra: 203,
    wireLength: 6,
    fields: [
      { name: "Vcc", type: "uint16_t", arrayLength: 0, extension: false, units: "mV" },
      { name: "Vservo", type: "uint16_t", arrayLength: 0, extension: false, units: "mV" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_POWER_STATUS" },
    ],
  },
  {
    id: 126,
    name: "SERIAL_CONTROL",
    crcExtra: 220,
    wireLength: 81,
    fields: [
      { name: "baudrate", type: "uint32_t", arrayLength: 0, extension: false, units: "bits/s" },
      { name: "timeout", type: "uint16_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "device", type: "uint8_t", arrayLength: 0, extension: false, enumName: "SERIAL_CONTROL_DEV" },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "SERIAL_CONTROL_FLAG" },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 70, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: true },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 127,
    name: "GPS_RTK",
    crcExtra: 25,
    wireLength: 35,
    fields: [
      { name: "time_last_baseline_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "tow", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "baseline_a_mm", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "baseline_b_mm", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "baseline_c_mm", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "accuracy", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "iar_num_hypotheses", type: "int32_t", arrayLength: 0, extension: false },
      { name: "wn", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "rtk_receiver_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rtk_health", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rtk_rate", type: "uint8_t", arrayLength: 0, extension: false, units: "Hz" },
      { name: "nsats", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "baseline_coords_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "RTK_BASELINE_COORDINATE_SYSTEM" },
    ],
  },
  {
    id: 128,
    name: "GPS2_RTK",
    crcExtra: 226,
    wireLength: 35,
    fields: [
      { name: "time_last_baseline_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "tow", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "baseline_a_mm", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "baseline_b_mm", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "baseline_c_mm", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "accuracy", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "iar_num_hypotheses", type: "int32_t", arrayLength: 0, extension: false },
      { name: "wn", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "rtk_receiver_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rtk_health", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rtk_rate", type: "uint8_t", arrayLength: 0, extension: false, units: "Hz" },
      { name: "nsats", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "baseline_coords_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "RTK_BASELINE_COORDINATE_SYSTEM" },
    ],
  },
  {
    id: 129,
    name: "SCALED_IMU3",
    crcExtra: 46,
    wireLength: 24,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "xacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "yacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "zacc", type: "int16_t", arrayLength: 0, extension: false, units: "mG" },
      { name: "xgyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "ygyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "zgyro", type: "int16_t", arrayLength: 0, extension: false, units: "mrad/s" },
      { name: "xmag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "ymag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "zmag", type: "int16_t", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: true, units: "cdegC", invalid: "0" },
    ],
  },
  {
    id: 130,
    name: "DATA_TRANSMISSION_HANDSHAKE",
    crcExtra: 29,
    wireLength: 13,
    fields: [
      { name: "size", type: "uint32_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "width", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "height", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "packets", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAVLINK_DATA_STREAM_TYPE" },
      { name: "payload", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "jpg_quality", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
    ],
  },
  {
    id: 131,
    name: "ENCAPSULATED_DATA",
    crcExtra: 223,
    wireLength: 255,
    fields: [
      { name: "seqnr", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 253, extension: false },
    ],
  },
  {
    id: 132,
    name: "DISTANCE_SENSOR",
    crcExtra: 85,
    wireLength: 39,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "min_distance", type: "uint16_t", arrayLength: 0, extension: false, units: "cm" },
      { name: "max_distance", type: "uint16_t", arrayLength: 0, extension: false, units: "cm" },
      { name: "current_distance", type: "uint16_t", arrayLength: 0, extension: false, units: "cm" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_DISTANCE_SENSOR" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "orientation", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_SENSOR_ORIENTATION" },
      { name: "covariance", type: "uint8_t", arrayLength: 0, extension: false, units: "cm^2", invalid: "UINT8_MAX" },
      { name: "horizontal_fov", type: "float", arrayLength: 0, extension: true, units: "rad", invalid: "0" },
      { name: "vertical_fov", type: "float", arrayLength: 0, extension: true, units: "rad", invalid: "0" },
      { name: "quaternion", type: "float", arrayLength: 4, extension: true, invalid: "[0]" },
      { name: "signal_quality", type: "uint8_t", arrayLength: 0, extension: true, units: "%", invalid: "0" },
    ],
  },
  {
    id: 133,
    name: "TERRAIN_REQUEST",
    crcExtra: 6,
    wireLength: 18,
    fields: [
      { name: "mask", type: "uint64_t", arrayLength: 0, extension: false, isBitmask: true, printFormat: "0x%07x" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "grid_spacing", type: "uint16_t", arrayLength: 0, extension: false, units: "m" },
    ],
  },
  {
    id: 134,
    name: "TERRAIN_DATA",
    crcExtra: 229,
    wireLength: 43,
    fields: [
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "grid_spacing", type: "uint16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "data", type: "int16_t", arrayLength: 16, extension: false, units: "m" },
      { name: "gridbit", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 135,
    name: "TERRAIN_CHECK",
    crcExtra: 203,
    wireLength: 8,
    fields: [
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
    ],
  },
  {
    id: 136,
    name: "TERRAIN_REPORT",
    crcExtra: 1,
    wireLength: 22,
    fields: [
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "terrain_height", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "current_height", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "spacing", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "pending", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "loaded", type: "uint16_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 137,
    name: "SCALED_PRESSURE2",
    crcExtra: 195,
    wireLength: 16,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "press_abs", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "press_diff", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC" },
      { name: "temperature_press_diff", type: "int16_t", arrayLength: 0, extension: true, units: "cdegC", invalid: "0" },
    ],
  },
  {
    id: 138,
    name: "ATT_POS_MOCAP",
    crcExtra: 109,
    wireLength: 120,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "covariance", type: "float", arrayLength: 21, extension: true, invalid: "[NaN:]" },
    ],
  },
  {
    id: 139,
    name: "SET_ACTUATOR_CONTROL_TARGET",
    crcExtra: 168,
    wireLength: 43,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "controls", type: "float", arrayLength: 8, extension: false },
      { name: "group_mlx", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 140,
    name: "ACTUATOR_CONTROL_TARGET",
    crcExtra: 181,
    wireLength: 41,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "controls", type: "float", arrayLength: 8, extension: false },
      { name: "group_mlx", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 141,
    name: "ALTITUDE",
    crcExtra: 47,
    wireLength: 32,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "altitude_monotonic", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "altitude_amsl", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "altitude_local", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "altitude_relative", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "altitude_terrain", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "bottom_clearance", type: "float", arrayLength: 0, extension: false, units: "m" },
    ],
  },
  {
    id: 142,
    name: "RESOURCE_REQUEST",
    crcExtra: 72,
    wireLength: 243,
    fields: [
      { name: "request_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "uri_type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "uri", type: "uint8_t", arrayLength: 120, extension: false },
      { name: "transfer_type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "storage", type: "uint8_t", arrayLength: 120, extension: false },
    ],
  },
  {
    id: 143,
    name: "SCALED_PRESSURE3",
    crcExtra: 131,
    wireLength: 16,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "press_abs", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "press_diff", type: "float", arrayLength: 0, extension: false, units: "hPa" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC" },
      { name: "temperature_press_diff", type: "int16_t", arrayLength: 0, extension: true, units: "cdegC", invalid: "0" },
    ],
  },
  {
    id: 144,
    name: "FOLLOW_TARGET",
    crcExtra: 127,
    wireLength: 93,
    fields: [
      { name: "timestamp", type: "uint64_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "custom_state", type: "uint64_t", arrayLength: 0, extension: false },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vel", type: "float", arrayLength: 3, extension: false, units: "m/s", invalid: "[0]" },
      { name: "acc", type: "float", arrayLength: 3, extension: false, units: "m/s/s", invalid: "[0]" },
      { name: "attitude_q", type: "float", arrayLength: 4, extension: false, invalid: "[0]" },
      { name: "rates", type: "float", arrayLength: 3, extension: false, units: "rad/s", invalid: "[0]" },
      { name: "position_cov", type: "float", arrayLength: 3, extension: false },
      { name: "est_capabilities", type: "uint8_t", arrayLength: 0, extension: false, enumName: "FOLLOW_TARGET_CAP_FLAGS" },
    ],
  },
  {
    id: 146,
    name: "CONTROL_SYSTEM_STATE",
    crcExtra: 103,
    wireLength: 100,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x_acc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "y_acc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "z_acc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "x_vel", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "y_vel", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "z_vel", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "x_pos", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y_pos", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z_pos", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "airspeed", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "-1" },
      { name: "vel_variance", type: "float", arrayLength: 3, extension: false },
      { name: "pos_variance", type: "float", arrayLength: 3, extension: false },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "roll_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitch_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
    ],
  },
  {
    id: 147,
    name: "BATTERY_STATUS",
    crcExtra: 154,
    wireLength: 54,
    fields: [
      { name: "current_consumed", type: "int32_t", arrayLength: 0, extension: false, units: "mAh", invalid: "-1" },
      { name: "energy_consumed", type: "int32_t", arrayLength: 0, extension: false, units: "hJ", invalid: "-1" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC", invalid: "INT16_MAX" },
      { name: "voltages", type: "uint16_t", arrayLength: 10, extension: false, units: "mV", invalid: "[UINT16_MAX]" },
      { name: "current_battery", type: "int16_t", arrayLength: 0, extension: false, units: "cA", invalid: "-1" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "battery_function", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_BATTERY_FUNCTION" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_BATTERY_TYPE" },
      { name: "battery_remaining", type: "int8_t", arrayLength: 0, extension: false, units: "%", invalid: "-1" },
      { name: "time_remaining", type: "int32_t", arrayLength: 0, extension: true, units: "s", invalid: "0" },
      { name: "charge_state", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_BATTERY_CHARGE_STATE" },
      { name: "voltages_ext", type: "uint16_t", arrayLength: 4, extension: true, units: "mV", invalid: "[0]" },
      { name: "mode", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_BATTERY_MODE" },
      { name: "fault_bitmask", type: "uint32_t", arrayLength: 0, extension: true, enumName: "MAV_BATTERY_FAULT" },
    ],
  },
  {
    id: 148,
    name: "AUTOPILOT_VERSION",
    crcExtra: 178,
    wireLength: 78,
    fields: [
      { name: "capabilities", type: "uint64_t", arrayLength: 0, extension: false, enumName: "MAV_PROTOCOL_CAPABILITY" },
      { name: "uid", type: "uint64_t", arrayLength: 0, extension: false },
      { name: "flight_sw_version", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "middleware_sw_version", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "os_sw_version", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "board_version", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "vendor_id", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "product_id", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "flight_custom_version", type: "uint8_t", arrayLength: 8, extension: false },
      { name: "middleware_custom_version", type: "uint8_t", arrayLength: 8, extension: false },
      { name: "os_custom_version", type: "uint8_t", arrayLength: 8, extension: false },
      { name: "uid2", type: "uint8_t", arrayLength: 18, extension: true },
    ],
  },
  {
    id: 149,
    name: "LANDING_TARGET",
    crcExtra: 200,
    wireLength: 60,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "angle_x", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "angle_y", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "size_x", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "size_y", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "target_num", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
      { name: "x", type: "float", arrayLength: 0, extension: true, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: true, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: true, units: "m" },
      { name: "q", type: "float", arrayLength: 4, extension: true },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "LANDING_TARGET_TYPE" },
      { name: "position_valid", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_BOOL", defaultValue: "0" },
    ],
  },
  {
    id: 150,
    name: "SENSOR_OFFSETS",
    crcExtra: 134,
    wireLength: 42,
    fields: [
      { name: "mag_declination", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "raw_press", type: "int32_t", arrayLength: 0, extension: false },
      { name: "raw_temp", type: "int32_t", arrayLength: 0, extension: false },
      { name: "gyro_cal_x", type: "float", arrayLength: 0, extension: false },
      { name: "gyro_cal_y", type: "float", arrayLength: 0, extension: false },
      { name: "gyro_cal_z", type: "float", arrayLength: 0, extension: false },
      { name: "accel_cal_x", type: "float", arrayLength: 0, extension: false },
      { name: "accel_cal_y", type: "float", arrayLength: 0, extension: false },
      { name: "accel_cal_z", type: "float", arrayLength: 0, extension: false },
      { name: "mag_ofs_x", type: "int16_t", arrayLength: 0, extension: false },
      { name: "mag_ofs_y", type: "int16_t", arrayLength: 0, extension: false },
      { name: "mag_ofs_z", type: "int16_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 151,
    name: "SET_MAG_OFFSETS",
    crcExtra: 219,
    wireLength: 8,
    fields: [
      { name: "mag_ofs_x", type: "int16_t", arrayLength: 0, extension: false },
      { name: "mag_ofs_y", type: "int16_t", arrayLength: 0, extension: false },
      { name: "mag_ofs_z", type: "int16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 152,
    name: "MEMINFO",
    crcExtra: 208,
    wireLength: 8,
    fields: [
      { name: "brkval", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "freemem", type: "uint16_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "freemem32", type: "uint32_t", arrayLength: 0, extension: true, units: "bytes" },
    ],
  },
  {
    id: 153,
    name: "AP_ADC",
    crcExtra: 188,
    wireLength: 12,
    fields: [
      { name: "adc1", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "adc2", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "adc3", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "adc4", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "adc5", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "adc6", type: "uint16_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 154,
    name: "DIGICAM_CONFIGURE",
    crcExtra: 84,
    wireLength: 15,
    fields: [
      { name: "extra_value", type: "float", arrayLength: 0, extension: false },
      { name: "shutter_speed", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mode", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "aperture", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "iso", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "exposure_type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "command_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "engine_cut_off", type: "uint8_t", arrayLength: 0, extension: false, units: "ds" },
      { name: "extra_param", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 155,
    name: "DIGICAM_CONTROL",
    crcExtra: 22,
    wireLength: 13,
    fields: [
      { name: "extra_value", type: "float", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "session", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "zoom_pos", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "zoom_step", type: "int8_t", arrayLength: 0, extension: false },
      { name: "focus_lock", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "shot", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "command_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "extra_param", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 156,
    name: "MOUNT_CONFIGURE",
    crcExtra: 19,
    wireLength: 6,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mount_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_MOUNT_MODE" },
      { name: "stab_roll", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "stab_pitch", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "stab_yaw", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 157,
    name: "MOUNT_CONTROL",
    crcExtra: 21,
    wireLength: 15,
    fields: [
      { name: "input_a", type: "int32_t", arrayLength: 0, extension: false },
      { name: "input_b", type: "int32_t", arrayLength: 0, extension: false },
      { name: "input_c", type: "int32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "save_position", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 158,
    name: "MOUNT_STATUS",
    crcExtra: 134,
    wireLength: 15,
    fields: [
      { name: "pointing_a", type: "int32_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "pointing_b", type: "int32_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "pointing_c", type: "int32_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mount_mode", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_MOUNT_MODE" },
    ],
  },
  {
    id: 160,
    name: "FENCE_POINT",
    crcExtra: 78,
    wireLength: 12,
    fields: [
      { name: "lat", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "lng", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "idx", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 161,
    name: "FENCE_FETCH_POINT",
    crcExtra: 68,
    wireLength: 3,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "idx", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 162,
    name: "FENCE_STATUS",
    crcExtra: 189,
    wireLength: 9,
    fields: [
      { name: "breach_time", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "breach_count", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "breach_status", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "breach_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "FENCE_BREACH" },
      { name: "breach_mitigation", type: "uint8_t", arrayLength: 0, extension: true, enumName: "FENCE_MITIGATE" },
    ],
  },
  {
    id: 163,
    name: "AHRS",
    crcExtra: 127,
    wireLength: 28,
    fields: [
      { name: "omegaIx", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "omegaIy", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "omegaIz", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "accel_weight", type: "float", arrayLength: 0, extension: false },
      { name: "renorm_val", type: "float", arrayLength: 0, extension: false },
      { name: "error_rp", type: "float", arrayLength: 0, extension: false },
      { name: "error_yaw", type: "float", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 164,
    name: "SIMSTATE",
    crcExtra: 154,
    wireLength: 44,
    fields: [
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "xacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "yacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "zacc", type: "float", arrayLength: 0, extension: false, units: "m/s/s" },
      { name: "xgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "ygyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "zgyro", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lng", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
    ],
  },
  {
    id: 165,
    name: "HWSTATUS",
    crcExtra: 21,
    wireLength: 3,
    fields: [
      { name: "Vcc", type: "uint16_t", arrayLength: 0, extension: false, units: "mV" },
      { name: "I2Cerr", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 166,
    name: "RADIO",
    crcExtra: 21,
    wireLength: 9,
    fields: [
      { name: "rxerrors", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "fixed", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "rssi", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "remrssi", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "txbuf", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
      { name: "noise", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "remnoise", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 167,
    name: "LIMITS_STATUS",
    crcExtra: 144,
    wireLength: 22,
    fields: [
      { name: "last_trigger", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "last_action", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "last_recovery", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "last_clear", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "breach_count", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "limits_state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "LIMITS_STATE" },
      { name: "mods_enabled", type: "uint8_t", arrayLength: 0, extension: false, enumName: "LIMIT_MODULE" },
      { name: "mods_required", type: "uint8_t", arrayLength: 0, extension: false, enumName: "LIMIT_MODULE" },
      { name: "mods_triggered", type: "uint8_t", arrayLength: 0, extension: false, enumName: "LIMIT_MODULE" },
    ],
  },
  {
    id: 168,
    name: "WIND",
    crcExtra: 1,
    wireLength: 12,
    fields: [
      { name: "direction", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "speed", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "speed_z", type: "float", arrayLength: 0, extension: false, units: "m/s" },
    ],
  },
  {
    id: 169,
    name: "DATA16",
    crcExtra: 234,
    wireLength: 18,
    fields: [
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 16, extension: false },
    ],
  },
  {
    id: 170,
    name: "DATA32",
    crcExtra: 73,
    wireLength: 34,
    fields: [
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 32, extension: false },
    ],
  },
  {
    id: 171,
    name: "DATA64",
    crcExtra: 181,
    wireLength: 66,
    fields: [
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 64, extension: false },
    ],
  },
  {
    id: 172,
    name: "DATA96",
    crcExtra: 22,
    wireLength: 98,
    fields: [
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 96, extension: false },
    ],
  },
  {
    id: 173,
    name: "RANGEFINDER",
    crcExtra: 83,
    wireLength: 8,
    fields: [
      { name: "distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "voltage", type: "float", arrayLength: 0, extension: false, units: "V" },
    ],
  },
  {
    id: 174,
    name: "AIRSPEED_AUTOCAL",
    crcExtra: 167,
    wireLength: 48,
    fields: [
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "diff_pressure", type: "float", arrayLength: 0, extension: false, units: "Pa" },
      { name: "EAS2TAS", type: "float", arrayLength: 0, extension: false },
      { name: "ratio", type: "float", arrayLength: 0, extension: false },
      { name: "state_x", type: "float", arrayLength: 0, extension: false },
      { name: "state_y", type: "float", arrayLength: 0, extension: false },
      { name: "state_z", type: "float", arrayLength: 0, extension: false },
      { name: "Pax", type: "float", arrayLength: 0, extension: false },
      { name: "Pby", type: "float", arrayLength: 0, extension: false },
      { name: "Pcz", type: "float", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 175,
    name: "RALLY_POINT",
    crcExtra: 138,
    wireLength: 19,
    fields: [
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lng", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "break_alt", type: "int16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "land_dir", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "idx", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "RALLY_FLAGS" },
    ],
  },
  {
    id: 176,
    name: "RALLY_FETCH_POINT",
    crcExtra: 234,
    wireLength: 3,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "idx", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 177,
    name: "COMPASSMOT_STATUS",
    crcExtra: 240,
    wireLength: 20,
    fields: [
      { name: "current", type: "float", arrayLength: 0, extension: false, units: "A" },
      { name: "CompensationX", type: "float", arrayLength: 0, extension: false },
      { name: "CompensationY", type: "float", arrayLength: 0, extension: false },
      { name: "CompensationZ", type: "float", arrayLength: 0, extension: false },
      { name: "throttle", type: "uint16_t", arrayLength: 0, extension: false, units: "d%" },
      { name: "interference", type: "uint16_t", arrayLength: 0, extension: false, units: "%" },
    ],
  },
  {
    id: 178,
    name: "AHRS2",
    crcExtra: 47,
    wireLength: 24,
    fields: [
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "altitude", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lng", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
    ],
  },
  {
    id: 179,
    name: "CAMERA_STATUS",
    crcExtra: 189,
    wireLength: 29,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "p1", type: "float", arrayLength: 0, extension: false },
      { name: "p2", type: "float", arrayLength: 0, extension: false },
      { name: "p3", type: "float", arrayLength: 0, extension: false },
      { name: "p4", type: "float", arrayLength: 0, extension: false },
      { name: "img_idx", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cam_idx", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "event_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAMERA_STATUS_TYPES" },
    ],
  },
  {
    id: 180,
    name: "CAMERA_FEEDBACK",
    crcExtra: 52,
    wireLength: 47,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lng", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt_msl", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "alt_rel", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "foc_len", type: "float", arrayLength: 0, extension: false, units: "mm" },
      { name: "img_idx", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cam_idx", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAMERA_FEEDBACK_FLAGS" },
      { name: "completed_captures", type: "uint16_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 181,
    name: "BATTERY2",
    crcExtra: 174,
    wireLength: 4,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 0, extension: false, units: "mV" },
      { name: "current_battery", type: "int16_t", arrayLength: 0, extension: false, units: "cA" },
    ],
  },
  {
    id: 182,
    name: "AHRS3",
    crcExtra: 229,
    wireLength: 40,
    fields: [
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "altitude", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lng", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "v1", type: "float", arrayLength: 0, extension: false },
      { name: "v2", type: "float", arrayLength: 0, extension: false },
      { name: "v3", type: "float", arrayLength: 0, extension: false },
      { name: "v4", type: "float", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 183,
    name: "AUTOPILOT_VERSION_REQUEST",
    crcExtra: 85,
    wireLength: 2,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 184,
    name: "REMOTE_LOG_DATA_BLOCK",
    crcExtra: 159,
    wireLength: 206,
    fields: [
      { name: "seqno", type: "uint32_t", arrayLength: 0, extension: false, enumName: "MAV_REMOTE_LOG_DATA_BLOCK_COMMANDS" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 200, extension: false },
    ],
  },
  {
    id: 185,
    name: "REMOTE_LOG_BLOCK_STATUS",
    crcExtra: 186,
    wireLength: 7,
    fields: [
      { name: "seqno", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_REMOTE_LOG_DATA_BLOCK_STATUSES" },
    ],
  },
  {
    id: 186,
    name: "LED_CONTROL",
    crcExtra: 72,
    wireLength: 29,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "instance", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "pattern", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "custom_len", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "custom_bytes", type: "uint8_t", arrayLength: 24, extension: false },
    ],
  },
  {
    id: 191,
    name: "MAG_CAL_PROGRESS",
    crcExtra: 92,
    wireLength: 27,
    fields: [
      { name: "direction_x", type: "float", arrayLength: 0, extension: false },
      { name: "direction_y", type: "float", arrayLength: 0, extension: false },
      { name: "direction_z", type: "float", arrayLength: 0, extension: false },
      { name: "compass_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cal_mask", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cal_status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAG_CAL_STATUS" },
      { name: "attempt", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "completion_pct", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
      { name: "completion_mask", type: "uint8_t", arrayLength: 10, extension: false },
    ],
  },
  {
    id: 192,
    name: "MAG_CAL_REPORT",
    crcExtra: 36,
    wireLength: 54,
    fields: [
      { name: "fitness", type: "float", arrayLength: 0, extension: false, units: "mgauss" },
      { name: "ofs_x", type: "float", arrayLength: 0, extension: false },
      { name: "ofs_y", type: "float", arrayLength: 0, extension: false },
      { name: "ofs_z", type: "float", arrayLength: 0, extension: false },
      { name: "diag_x", type: "float", arrayLength: 0, extension: false },
      { name: "diag_y", type: "float", arrayLength: 0, extension: false },
      { name: "diag_z", type: "float", arrayLength: 0, extension: false },
      { name: "offdiag_x", type: "float", arrayLength: 0, extension: false },
      { name: "offdiag_y", type: "float", arrayLength: 0, extension: false },
      { name: "offdiag_z", type: "float", arrayLength: 0, extension: false },
      { name: "compass_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cal_mask", type: "uint8_t", arrayLength: 0, extension: false, isBitmask: true },
      { name: "cal_status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAG_CAL_STATUS" },
      { name: "autosaved", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "orientation_confidence", type: "float", arrayLength: 0, extension: true },
      { name: "old_orientation", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_SENSOR_ORIENTATION" },
      { name: "new_orientation", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_SENSOR_ORIENTATION" },
      { name: "scale_factor", type: "float", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 193,
    name: "EKF_STATUS_REPORT",
    crcExtra: 71,
    wireLength: 26,
    fields: [
      { name: "velocity_variance", type: "float", arrayLength: 0, extension: false },
      { name: "pos_horiz_variance", type: "float", arrayLength: 0, extension: false },
      { name: "pos_vert_variance", type: "float", arrayLength: 0, extension: false },
      { name: "compass_variance", type: "float", arrayLength: 0, extension: false },
      { name: "terrain_alt_variance", type: "float", arrayLength: 0, extension: false },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "EKF_STATUS_FLAGS" },
      { name: "airspeed_variance", type: "float", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 194,
    name: "PID_TUNING",
    crcExtra: 98,
    wireLength: 33,
    fields: [
      { name: "desired", type: "float", arrayLength: 0, extension: false },
      { name: "achieved", type: "float", arrayLength: 0, extension: false },
      { name: "FF", type: "float", arrayLength: 0, extension: false },
      { name: "P", type: "float", arrayLength: 0, extension: false },
      { name: "I", type: "float", arrayLength: 0, extension: false },
      { name: "D", type: "float", arrayLength: 0, extension: false },
      { name: "axis", type: "uint8_t", arrayLength: 0, extension: false, enumName: "PID_TUNING_AXIS" },
      { name: "SRate", type: "float", arrayLength: 0, extension: true },
      { name: "PDmod", type: "float", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 195,
    name: "DEEPSTALL",
    crcExtra: 120,
    wireLength: 37,
    fields: [
      { name: "landing_lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "landing_lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "path_lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "path_lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "arc_entry_lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "arc_entry_lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "altitude", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "expected_travel_distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "cross_track_error", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "stage", type: "uint8_t", arrayLength: 0, extension: false, enumName: "DEEPSTALL_STAGE" },
    ],
  },
  {
    id: 200,
    name: "GIMBAL_REPORT",
    crcExtra: 134,
    wireLength: 42,
    fields: [
      { name: "delta_time", type: "float", arrayLength: 0, extension: false, units: "s" },
      { name: "delta_angle_x", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "delta_angle_y", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "delta_angle_z", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "delta_velocity_x", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "delta_velocity_y", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "delta_velocity_z", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "joint_roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "joint_el", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "joint_az", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 201,
    name: "GIMBAL_CONTROL",
    crcExtra: 205,
    wireLength: 14,
    fields: [
      { name: "demanded_rate_x", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "demanded_rate_y", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "demanded_rate_z", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 214,
    name: "GIMBAL_TORQUE_CMD_REPORT",
    crcExtra: 69,
    wireLength: 8,
    fields: [
      { name: "rl_torque_cmd", type: "int16_t", arrayLength: 0, extension: false },
      { name: "el_torque_cmd", type: "int16_t", arrayLength: 0, extension: false },
      { name: "az_torque_cmd", type: "int16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 215,
    name: "GOPRO_HEARTBEAT",
    crcExtra: 101,
    wireLength: 3,
    fields: [
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_HEARTBEAT_STATUS" },
      { name: "capture_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_CAPTURE_MODE" },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_HEARTBEAT_FLAGS" },
    ],
  },
  {
    id: 216,
    name: "GOPRO_GET_REQUEST",
    crcExtra: 50,
    wireLength: 3,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cmd_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_COMMAND" },
    ],
  },
  {
    id: 217,
    name: "GOPRO_GET_RESPONSE",
    crcExtra: 202,
    wireLength: 6,
    fields: [
      { name: "cmd_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_COMMAND" },
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_REQUEST_STATUS" },
      { name: "value", type: "uint8_t", arrayLength: 4, extension: false },
    ],
  },
  {
    id: 218,
    name: "GOPRO_SET_REQUEST",
    crcExtra: 17,
    wireLength: 7,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cmd_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_COMMAND" },
      { name: "value", type: "uint8_t", arrayLength: 4, extension: false },
    ],
  },
  {
    id: 219,
    name: "GOPRO_SET_RESPONSE",
    crcExtra: 162,
    wireLength: 2,
    fields: [
      { name: "cmd_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_COMMAND" },
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GOPRO_REQUEST_STATUS" },
    ],
  },
  {
    id: 225,
    name: "EFI_STATUS",
    crcExtra: 208,
    wireLength: 73,
    fields: [
      { name: "ecu_index", type: "float", arrayLength: 0, extension: false },
      { name: "rpm", type: "float", arrayLength: 0, extension: false },
      { name: "fuel_consumed", type: "float", arrayLength: 0, extension: false, units: "cm^3" },
      { name: "fuel_flow", type: "float", arrayLength: 0, extension: false, units: "cm^3/min" },
      { name: "engine_load", type: "float", arrayLength: 0, extension: false, units: "%" },
      { name: "throttle_position", type: "float", arrayLength: 0, extension: false, units: "%" },
      { name: "spark_dwell_time", type: "float", arrayLength: 0, extension: false, units: "ms" },
      { name: "barometric_pressure", type: "float", arrayLength: 0, extension: false, units: "kPa" },
      { name: "intake_manifold_pressure", type: "float", arrayLength: 0, extension: false, units: "kPa" },
      { name: "intake_manifold_temperature", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "cylinder_head_temperature", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "ignition_timing", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "injection_time", type: "float", arrayLength: 0, extension: false, units: "ms" },
      { name: "exhaust_gas_temperature", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "throttle_out", type: "float", arrayLength: 0, extension: false, units: "%" },
      { name: "pt_compensation", type: "float", arrayLength: 0, extension: false },
      { name: "health", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "ignition_voltage", type: "float", arrayLength: 0, extension: true, units: "V" },
      { name: "fuel_pressure", type: "float", arrayLength: 0, extension: true, units: "kPa" },
    ],
  },
  {
    id: 226,
    name: "RPM",
    crcExtra: 207,
    wireLength: 8,
    fields: [
      { name: "rpm1", type: "float", arrayLength: 0, extension: false },
      { name: "rpm2", type: "float", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 230,
    name: "ESTIMATOR_STATUS",
    crcExtra: 163,
    wireLength: 42,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "vel_ratio", type: "float", arrayLength: 0, extension: false },
      { name: "pos_horiz_ratio", type: "float", arrayLength: 0, extension: false },
      { name: "pos_vert_ratio", type: "float", arrayLength: 0, extension: false },
      { name: "mag_ratio", type: "float", arrayLength: 0, extension: false },
      { name: "hagl_ratio", type: "float", arrayLength: 0, extension: false },
      { name: "tas_ratio", type: "float", arrayLength: 0, extension: false },
      { name: "pos_horiz_accuracy", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "pos_vert_accuracy", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "ESTIMATOR_STATUS_FLAGS" },
    ],
  },
  {
    id: 231,
    name: "WIND_COV",
    crcExtra: 105,
    wireLength: 40,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "wind_x", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "wind_y", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "wind_z", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "var_horiz", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "var_vert", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "wind_alt", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "horiz_accuracy", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "0" },
      { name: "vert_accuracy", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "0" },
    ],
  },
  {
    id: 232,
    name: "GPS_INPUT",
    crcExtra: 151,
    wireLength: 65,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "time_week_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "hdop", type: "float", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "vdop", type: "float", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "vn", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "ve", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vd", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "speed_accuracy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "horiz_accuracy", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "vert_accuracy", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "ignore_flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "GPS_INPUT_IGNORE_FLAGS" },
      { name: "time_week", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "gps_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "fix_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GPS_FIX_TYPE" },
      { name: "satellites_visible", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "yaw", type: "uint16_t", arrayLength: 0, extension: true, units: "cdeg", invalid: "0" },
    ],
  },
  {
    id: 233,
    name: "GPS_RTCM_DATA",
    crcExtra: 35,
    wireLength: 182,
    fields: [
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "data", type: "uint8_t", arrayLength: 180, extension: false },
    ],
  },
  {
    id: 234,
    name: "HIGH_LATENCY",
    crcExtra: 150,
    wireLength: 40,
    fields: [
      { name: "custom_mode", type: "uint32_t", arrayLength: 0, extension: false, isBitmask: true },
      { name: "latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "roll", type: "int16_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "pitch", type: "int16_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "heading", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "heading_sp", type: "int16_t", arrayLength: 0, extension: false, units: "cdeg" },
      { name: "altitude_amsl", type: "int16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "altitude_sp", type: "int16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "wp_distance", type: "uint16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "base_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_MODE_FLAG" },
      { name: "landed_state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_LANDED_STATE" },
      { name: "throttle", type: "int8_t", arrayLength: 0, extension: false, units: "%" },
      { name: "airspeed", type: "uint8_t", arrayLength: 0, extension: false, units: "m/s" },
      { name: "airspeed_sp", type: "uint8_t", arrayLength: 0, extension: false, units: "m/s" },
      { name: "groundspeed", type: "uint8_t", arrayLength: 0, extension: false, units: "m/s" },
      { name: "climb_rate", type: "int8_t", arrayLength: 0, extension: false, units: "m/s" },
      { name: "gps_nsat", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "gps_fix_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GPS_FIX_TYPE" },
      { name: "battery_remaining", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
      { name: "temperature", type: "int8_t", arrayLength: 0, extension: false, units: "degC" },
      { name: "temperature_air", type: "int8_t", arrayLength: 0, extension: false, units: "degC" },
      { name: "failsafe", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "wp_num", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 235,
    name: "HIGH_LATENCY2",
    crcExtra: 179,
    wireLength: 42,
    fields: [
      { name: "timestamp", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "custom_mode", type: "uint16_t", arrayLength: 0, extension: false, isBitmask: true },
      { name: "altitude", type: "int16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "target_altitude", type: "int16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "target_distance", type: "uint16_t", arrayLength: 0, extension: false, units: "dam" },
      { name: "wp_num", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "failure_flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "HL_FAILURE_FLAG" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_TYPE" },
      { name: "autopilot", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_AUTOPILOT" },
      { name: "heading", type: "uint8_t", arrayLength: 0, extension: false, units: "deg/2" },
      { name: "target_heading", type: "uint8_t", arrayLength: 0, extension: false, units: "deg/2" },
      { name: "throttle", type: "uint8_t", arrayLength: 0, extension: false, units: "%" },
      { name: "airspeed", type: "uint8_t", arrayLength: 0, extension: false, units: "m/s*5" },
      { name: "airspeed_sp", type: "uint8_t", arrayLength: 0, extension: false, units: "m/s*5" },
      { name: "groundspeed", type: "uint8_t", arrayLength: 0, extension: false, units: "m/s*5" },
      { name: "windspeed", type: "uint8_t", arrayLength: 0, extension: false, units: "m/s*5" },
      { name: "wind_heading", type: "uint8_t", arrayLength: 0, extension: false, units: "deg/2" },
      { name: "eph", type: "uint8_t", arrayLength: 0, extension: false, units: "dm" },
      { name: "epv", type: "uint8_t", arrayLength: 0, extension: false, units: "dm" },
      { name: "temperature_air", type: "int8_t", arrayLength: 0, extension: false, units: "degC" },
      { name: "climb_rate", type: "int8_t", arrayLength: 0, extension: false, units: "dm/s" },
      { name: "battery", type: "int8_t", arrayLength: 0, extension: false, units: "%", invalid: "-1" },
      { name: "custom0", type: "int8_t", arrayLength: 0, extension: false },
      { name: "custom1", type: "int8_t", arrayLength: 0, extension: false },
      { name: "custom2", type: "int8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 241,
    name: "VIBRATION",
    crcExtra: 90,
    wireLength: 32,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "vibration_x", type: "float", arrayLength: 0, extension: false },
      { name: "vibration_y", type: "float", arrayLength: 0, extension: false },
      { name: "vibration_z", type: "float", arrayLength: 0, extension: false },
      { name: "clipping_0", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "clipping_1", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "clipping_2", type: "uint32_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 242,
    name: "HOME_POSITION",
    crcExtra: 104,
    wireLength: 60,
    fields: [
      { name: "latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "altitude", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "q", type: "float", arrayLength: 4, extension: false, invalid: "[NaN]" },
      { name: "approach_x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "approach_y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "approach_z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: true, units: "us" },
    ],
  },
  {
    id: 243,
    name: "SET_HOME_POSITION",
    crcExtra: 85,
    wireLength: 61,
    fields: [
      { name: "latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "altitude", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "approach_x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "approach_y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "approach_z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: true, units: "us" },
    ],
  },
  {
    id: 244,
    name: "MESSAGE_INTERVAL",
    crcExtra: 95,
    wireLength: 6,
    fields: [
      { name: "interval_us", type: "int32_t", arrayLength: 0, extension: false, units: "us" },
      { name: "message_id", type: "uint16_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 245,
    name: "EXTENDED_SYS_STATE",
    crcExtra: 130,
    wireLength: 2,
    fields: [
      { name: "vtol_state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_VTOL_STATE" },
      { name: "landed_state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_LANDED_STATE" },
    ],
  },
  {
    id: 246,
    name: "ADSB_VEHICLE",
    crcExtra: 184,
    wireLength: 38,
    fields: [
      { name: "ICAO_address", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "altitude", type: "int32_t", arrayLength: 0, extension: false, units: "mm", invalid: "INT32_MAX" },
      { name: "heading", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "UINT16_MAX" },
      { name: "hor_velocity", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s", invalid: "UINT16_MAX" },
      { name: "ver_velocity", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s", invalid: "INT16_MAX" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "ADSB_FLAGS" },
      { name: "squawk", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "altitude_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ADSB_ALTITUDE_TYPE" },
      { name: "callsign", type: "char", arrayLength: 9, extension: false },
      { name: "emitter_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ADSB_EMITTER_TYPE" },
      { name: "tslc", type: "uint8_t", arrayLength: 0, extension: false, units: "s" },
    ],
  },
  {
    id: 247,
    name: "COLLISION",
    crcExtra: 81,
    wireLength: 19,
    fields: [
      { name: "id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "time_to_minimum_delta", type: "float", arrayLength: 0, extension: false, units: "s" },
      { name: "altitude_minimum_delta", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "horizontal_minimum_delta", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "src", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_COLLISION_SRC" },
      { name: "action", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_COLLISION_ACTION" },
      { name: "threat_level", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_COLLISION_THREAT_LEVEL" },
    ],
  },
  {
    id: 248,
    name: "V2_EXTENSION",
    crcExtra: 8,
    wireLength: 254,
    fields: [
      { name: "message_type", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_network", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "payload", type: "uint8_t", arrayLength: 249, extension: false },
    ],
  },
  {
    id: 249,
    name: "MEMORY_VECT",
    crcExtra: 204,
    wireLength: 36,
    fields: [
      { name: "address", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "ver", type: "uint8_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "value", type: "int8_t", arrayLength: 32, extension: false },
    ],
  },
  {
    id: 250,
    name: "DEBUG_VECT",
    crcExtra: 49,
    wireLength: 30,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x", type: "float", arrayLength: 0, extension: false },
      { name: "y", type: "float", arrayLength: 0, extension: false },
      { name: "z", type: "float", arrayLength: 0, extension: false },
      { name: "name", type: "char", arrayLength: 10, extension: false },
    ],
  },
  {
    id: 251,
    name: "NAMED_VALUE_FLOAT",
    crcExtra: 170,
    wireLength: 18,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "value", type: "float", arrayLength: 0, extension: false },
      { name: "name", type: "char", arrayLength: 10, extension: false },
    ],
  },
  {
    id: 252,
    name: "NAMED_VALUE_INT",
    crcExtra: 44,
    wireLength: 18,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "value", type: "int32_t", arrayLength: 0, extension: false },
      { name: "name", type: "char", arrayLength: 10, extension: false },
    ],
  },
  {
    id: 253,
    name: "STATUSTEXT",
    crcExtra: 83,
    wireLength: 54,
    fields: [
      { name: "severity", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_SEVERITY" },
      { name: "text", type: "char", arrayLength: 50, extension: false },
      { name: "id", type: "uint16_t", arrayLength: 0, extension: true },
      { name: "chunk_seq", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 254,
    name: "DEBUG",
    crcExtra: 46,
    wireLength: 9,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "value", type: "float", arrayLength: 0, extension: false },
      { name: "ind", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 256,
    name: "SETUP_SIGNING",
    crcExtra: 71,
    wireLength: 42,
    fields: [
      { name: "initial_timestamp", type: "uint64_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "secret_key", type: "uint8_t", arrayLength: 32, extension: false },
    ],
  },
  {
    id: 257,
    name: "BUTTON_CHANGE",
    crcExtra: 131,
    wireLength: 9,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "last_change_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "state", type: "uint8_t", arrayLength: 0, extension: false, isBitmask: true },
    ],
  },
  {
    id: 258,
    name: "PLAY_TUNE",
    crcExtra: 187,
    wireLength: 232,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "tune", type: "char", arrayLength: 30, extension: false },
      { name: "tune2", type: "char", arrayLength: 200, extension: true },
    ],
  },
  {
    id: 259,
    name: "CAMERA_INFORMATION",
    crcExtra: 92,
    wireLength: 237,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "firmware_version", type: "uint32_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "focal_length", type: "float", arrayLength: 0, extension: false, units: "mm", invalid: "NaN" },
      { name: "sensor_size_h", type: "float", arrayLength: 0, extension: false, units: "mm", invalid: "NaN" },
      { name: "sensor_size_v", type: "float", arrayLength: 0, extension: false, units: "mm", invalid: "NaN" },
      { name: "flags", type: "uint32_t", arrayLength: 0, extension: false, enumName: "CAMERA_CAP_FLAGS" },
      { name: "resolution_h", type: "uint16_t", arrayLength: 0, extension: false, units: "pix", invalid: "0" },
      { name: "resolution_v", type: "uint16_t", arrayLength: 0, extension: false, units: "pix", invalid: "0" },
      { name: "cam_definition_version", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "vendor_name", type: "uint8_t", arrayLength: 32, extension: false },
      { name: "model_name", type: "uint8_t", arrayLength: 32, extension: false },
      { name: "lens_id", type: "uint8_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "cam_definition_uri", type: "char", arrayLength: 140, extension: false },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 260,
    name: "CAMERA_SETTINGS",
    crcExtra: 146,
    wireLength: 14,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "mode_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAMERA_MODE" },
      { name: "zoomLevel", type: "float", arrayLength: 0, extension: true, invalid: "NaN" },
      { name: "focusLevel", type: "float", arrayLength: 0, extension: true, invalid: "NaN" },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 261,
    name: "STORAGE_INFORMATION",
    crcExtra: 179,
    wireLength: 61,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "total_capacity", type: "float", arrayLength: 0, extension: false, units: "MiB" },
      { name: "used_capacity", type: "float", arrayLength: 0, extension: false, units: "MiB" },
      { name: "available_capacity", type: "float", arrayLength: 0, extension: false, units: "MiB" },
      { name: "read_speed", type: "float", arrayLength: 0, extension: false, units: "MiB/s" },
      { name: "write_speed", type: "float", arrayLength: 0, extension: false, units: "MiB/s" },
      { name: "storage_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "storage_count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "STORAGE_STATUS" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "STORAGE_TYPE" },
      { name: "name", type: "char", arrayLength: 32, extension: true },
      { name: "storage_usage", type: "uint8_t", arrayLength: 0, extension: true, enumName: "STORAGE_USAGE_FLAG" },
    ],
  },
  {
    id: 262,
    name: "CAMERA_CAPTURE_STATUS",
    crcExtra: 12,
    wireLength: 23,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "image_interval", type: "float", arrayLength: 0, extension: false, units: "s" },
      { name: "recording_time_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "available_capacity", type: "float", arrayLength: 0, extension: false, units: "MiB" },
      { name: "image_status", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "video_status", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "image_count", type: "int32_t", arrayLength: 0, extension: true },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 263,
    name: "CAMERA_IMAGE_CAPTURED",
    crcExtra: 133,
    wireLength: 255,
    fields: [
      { name: "time_utc", type: "uint64_t", arrayLength: 0, extension: false, units: "us", invalid: "0" },
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "relative_alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "image_index", type: "int32_t", arrayLength: 0, extension: false },
      { name: "camera_id", type: "uint8_t", arrayLength: 0, extension: false, defaultValue: "0", minValue: "0", maxValue: "6" },
      { name: "capture_result", type: "int8_t", arrayLength: 0, extension: false, enumName: "MAV_BOOL" },
      { name: "file_url", type: "char", arrayLength: 205, extension: false },
    ],
  },
  {
    id: 264,
    name: "FLIGHT_INFORMATION",
    crcExtra: 49,
    wireLength: 32,
    fields: [
      { name: "arming_time_utc", type: "uint64_t", arrayLength: 0, extension: false, units: "us", invalid: "0" },
      { name: "takeoff_time_utc", type: "uint64_t", arrayLength: 0, extension: false, units: "us", invalid: "0" },
      { name: "flight_uuid", type: "uint64_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "landing_time", type: "uint32_t", arrayLength: 0, extension: true, units: "ms", invalid: "0" },
    ],
  },
  {
    id: 265,
    name: "MOUNT_ORIENTATION",
    crcExtra: 26,
    wireLength: 20,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "deg", invalid: "NaN" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "deg", invalid: "NaN" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "deg", invalid: "NaN" },
      { name: "yaw_absolute", type: "float", arrayLength: 0, extension: true, units: "deg", invalid: "NaN" },
    ],
  },
  {
    id: 266,
    name: "LOGGING_DATA",
    crcExtra: 193,
    wireLength: 255,
    fields: [
      { name: "sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "length", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "first_message_offset", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes", invalid: "UINT8_MAX" },
      { name: "data", type: "uint8_t", arrayLength: 249, extension: false },
    ],
  },
  {
    id: 267,
    name: "LOGGING_DATA_ACKED",
    crcExtra: 35,
    wireLength: 255,
    fields: [
      { name: "sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "length", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "first_message_offset", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes", invalid: "UINT8_MAX" },
      { name: "data", type: "uint8_t", arrayLength: 249, extension: false },
    ],
  },
  {
    id: 268,
    name: "LOGGING_ACK",
    crcExtra: 14,
    wireLength: 4,
    fields: [
      { name: "sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 269,
    name: "VIDEO_STREAM_INFORMATION",
    crcExtra: 109,
    wireLength: 215,
    fields: [
      { name: "framerate", type: "float", arrayLength: 0, extension: false, units: "Hz" },
      { name: "bitrate", type: "uint32_t", arrayLength: 0, extension: false, units: "bits/s" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "VIDEO_STREAM_STATUS_FLAGS" },
      { name: "resolution_h", type: "uint16_t", arrayLength: 0, extension: false, units: "pix" },
      { name: "resolution_v", type: "uint16_t", arrayLength: 0, extension: false, units: "pix" },
      { name: "rotation", type: "uint16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "hfov", type: "uint16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "stream_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "VIDEO_STREAM_TYPE" },
      { name: "name", type: "char", arrayLength: 32, extension: false },
      { name: "uri", type: "char", arrayLength: 160, extension: false },
      { name: "encoding", type: "uint8_t", arrayLength: 0, extension: true, enumName: "VIDEO_STREAM_ENCODING" },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 270,
    name: "VIDEO_STREAM_STATUS",
    crcExtra: 59,
    wireLength: 20,
    fields: [
      { name: "framerate", type: "float", arrayLength: 0, extension: false, units: "Hz" },
      { name: "bitrate", type: "uint32_t", arrayLength: 0, extension: false, units: "bits/s" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "VIDEO_STREAM_STATUS_FLAGS" },
      { name: "resolution_h", type: "uint16_t", arrayLength: 0, extension: false, units: "pix" },
      { name: "resolution_v", type: "uint16_t", arrayLength: 0, extension: false, units: "pix" },
      { name: "rotation", type: "uint16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "hfov", type: "uint16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "stream_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 271,
    name: "CAMERA_FOV_STATUS",
    crcExtra: 22,
    wireLength: 53,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "lat_camera", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "lon_camera", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "alt_camera", type: "int32_t", arrayLength: 0, extension: false, units: "mm", invalid: "INT32_MAX" },
      { name: "lat_image", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "lon_image", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "alt_image", type: "int32_t", arrayLength: 0, extension: false, units: "mm", invalid: "INT32_MAX" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "hfov", type: "float", arrayLength: 0, extension: false, units: "deg", invalid: "NaN" },
      { name: "vfov", type: "float", arrayLength: 0, extension: false, units: "deg", invalid: "NaN" },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 275,
    name: "CAMERA_TRACKING_IMAGE_STATUS",
    crcExtra: 126,
    wireLength: 32,
    fields: [
      { name: "point_x", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "point_y", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "radius", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "rec_top_x", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "rec_top_y", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "rec_bottom_x", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "rec_bottom_y", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "tracking_status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAMERA_TRACKING_STATUS_FLAGS" },
      { name: "tracking_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAMERA_TRACKING_MODE" },
      { name: "target_data", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAMERA_TRACKING_TARGET_DATA" },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 276,
    name: "CAMERA_TRACKING_GEO_STATUS",
    crcExtra: 18,
    wireLength: 50,
    fields: [
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "h_acc", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "v_acc", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "vel_n", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "vel_e", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "vel_d", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "vel_acc", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "dist", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "hdg", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "hdg_acc", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "tracking_status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAMERA_TRACKING_STATUS_FLAGS" },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: true, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 277,
    name: "CAMERA_THERMAL_RANGE",
    crcExtra: 62,
    wireLength: 30,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "max", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "max_point_x", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "max_point_y", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "min", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "min_point_x", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "min_point_y", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "stream_id", type: "uint8_t", arrayLength: 0, extension: false, minValue: "1" },
      { name: "camera_device_id", type: "uint8_t", arrayLength: 0, extension: false, defaultValue: "0", minValue: "0", maxValue: "6" },
    ],
  },
  {
    id: 280,
    name: "GIMBAL_MANAGER_INFORMATION",
    crcExtra: 70,
    wireLength: 33,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "cap_flags", type: "uint32_t", arrayLength: 0, extension: false, enumName: "GIMBAL_MANAGER_CAP_FLAGS" },
      { name: "roll_min", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "roll_max", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch_min", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch_max", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw_min", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw_max", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 281,
    name: "GIMBAL_MANAGER_STATUS",
    crcExtra: 48,
    wireLength: 13,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "flags", type: "uint32_t", arrayLength: 0, extension: false, enumName: "GIMBAL_MANAGER_FLAGS" },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "primary_control_sysid", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "primary_control_compid", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "secondary_control_sysid", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "secondary_control_compid", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 282,
    name: "GIMBAL_MANAGER_SET_ATTITUDE",
    crcExtra: 123,
    wireLength: 35,
    fields: [
      { name: "flags", type: "uint32_t", arrayLength: 0, extension: false, enumName: "GIMBAL_MANAGER_FLAGS" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "angular_velocity_x", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "angular_velocity_y", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "angular_velocity_z", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 283,
    name: "GIMBAL_DEVICE_INFORMATION",
    crcExtra: 74,
    wireLength: 149,
    fields: [
      { name: "uid", type: "uint64_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "firmware_version", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "hardware_version", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "roll_min", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "roll_max", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "pitch_min", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "pitch_max", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "yaw_min", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "yaw_max", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "cap_flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "GIMBAL_DEVICE_CAP_FLAGS" },
      { name: "custom_cap_flags", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "vendor_name", type: "char", arrayLength: 32, extension: false },
      { name: "model_name", type: "char", arrayLength: 32, extension: false },
      { name: "custom_name", type: "char", arrayLength: 32, extension: false },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "cap_flags2", type: "uint32_t", arrayLength: 0, extension: true, enumName: "GIMBAL_DEVICE_CAP_FLAGS", invalid: "0" },
    ],
  },
  {
    id: 284,
    name: "GIMBAL_DEVICE_SET_ATTITUDE",
    crcExtra: 99,
    wireLength: 32,
    fields: [
      { name: "q", type: "float", arrayLength: 4, extension: false, invalid: "[NaN]" },
      { name: "angular_velocity_x", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "angular_velocity_y", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "angular_velocity_z", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "GIMBAL_DEVICE_FLAGS" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 285,
    name: "GIMBAL_DEVICE_ATTITUDE_STATUS",
    crcExtra: 137,
    wireLength: 49,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "angular_velocity_x", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "angular_velocity_y", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "angular_velocity_z", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "failure_flags", type: "uint32_t", arrayLength: 0, extension: false, enumName: "GIMBAL_DEVICE_ERROR_FLAGS" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "GIMBAL_DEVICE_FLAGS" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "delta_yaw", type: "float", arrayLength: 0, extension: true, units: "rad", invalid: "NAN" },
      { name: "delta_yaw_velocity", type: "float", arrayLength: 0, extension: true, units: "rad/s", invalid: "NAN" },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: true, invalid: "0" },
    ],
  },
  {
    id: 286,
    name: "AUTOPILOT_STATE_FOR_GIMBAL_DEVICE",
    crcExtra: 210,
    wireLength: 57,
    fields: [
      { name: "time_boot_us", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "q_estimated_delay_us", type: "uint32_t", arrayLength: 0, extension: false, units: "us", invalid: "0" },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "v_estimated_delay_us", type: "uint32_t", arrayLength: 0, extension: false, units: "us", invalid: "0" },
      { name: "feed_forward_angular_velocity_z", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "estimator_status", type: "uint16_t", arrayLength: 0, extension: false, enumName: "ESTIMATOR_STATUS_FLAGS" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "landed_state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_LANDED_STATE", invalid: "MAV_LANDED_STATE_UNDEFINED" },
      { name: "angular_velocity_z", type: "float", arrayLength: 0, extension: true, units: "rad/s", invalid: "0" },
    ],
  },
  {
    id: 287,
    name: "GIMBAL_MANAGER_SET_PITCHYAW",
    crcExtra: 1,
    wireLength: 23,
    fields: [
      { name: "flags", type: "uint32_t", arrayLength: 0, extension: false, enumName: "GIMBAL_MANAGER_FLAGS" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad", invalid: "NaN" },
      { name: "pitch_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "yaw_rate", type: "float", arrayLength: 0, extension: false, units: "rad/s", invalid: "NaN" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 288,
    name: "GIMBAL_MANAGER_SET_MANUAL_CONTROL",
    crcExtra: 20,
    wireLength: 23,
    fields: [
      { name: "flags", type: "uint32_t", arrayLength: 0, extension: false, enumName: "GIMBAL_MANAGER_FLAGS" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "pitch_rate", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "yaw_rate", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "gimbal_device_id", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 290,
    name: "ESC_INFO",
    crcExtra: 251,
    wireLength: 46,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "error_count", type: "uint32_t", arrayLength: 4, extension: false },
      { name: "counter", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "failure_flags", type: "uint16_t", arrayLength: 4, extension: false, enumName: "ESC_FAILURE_FLAGS" },
      { name: "temperature", type: "int16_t", arrayLength: 4, extension: false, units: "cdegC", invalid: "[INT16_MAX]" },
      { name: "index", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "connection_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ESC_CONNECTION_TYPE" },
      { name: "info", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 291,
    name: "ESC_STATUS",
    crcExtra: 10,
    wireLength: 57,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "rpm", type: "int32_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "voltage", type: "float", arrayLength: 4, extension: false, units: "V" },
      { name: "current", type: "float", arrayLength: 4, extension: false, units: "A" },
      { name: "index", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 295,
    name: "AIRSPEED",
    crcExtra: 234,
    wireLength: 12,
    fields: [
      { name: "airspeed", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "raw_press", type: "float", arrayLength: 0, extension: false, units: "hPa", invalid: "NaN" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC", invalid: "INT16_MAX" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "AIRSPEED_SENSOR_FLAGS" },
    ],
  },
  {
    id: 296,
    name: "GLOBAL_POSITION_SENSOR",
    crcExtra: 158,
    wireLength: 41,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "processing_time", type: "uint32_t", arrayLength: 0, extension: false, units: "us" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "alt_ellipsoid", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "eph", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "epv", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false, defaultValue: "0" },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false, defaultValue: "0" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "source", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GLOBAL_POSITION_SRC" },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "GLOBAL_POSITION_FLAGS" },
    ],
  },
  {
    id: 299,
    name: "WIFI_CONFIG_AP",
    crcExtra: 19,
    wireLength: 98,
    fields: [
      { name: "ssid", type: "char", arrayLength: 32, extension: false },
      { name: "password", type: "char", arrayLength: 64, extension: false },
      { name: "mode", type: "int8_t", arrayLength: 0, extension: true, enumName: "WIFI_CONFIG_AP_MODE" },
      { name: "response", type: "int8_t", arrayLength: 0, extension: true, enumName: "WIFI_CONFIG_AP_RESPONSE" },
    ],
  },
  {
    id: 300,
    name: "PROTOCOL_VERSION",
    crcExtra: 217,
    wireLength: 22,
    fields: [
      { name: "version", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "min_version", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "max_version", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "spec_version_hash", type: "uint8_t", arrayLength: 8, extension: false },
      { name: "library_version_hash", type: "uint8_t", arrayLength: 8, extension: false },
    ],
  },
  {
    id: 301,
    name: "AIS_VESSEL",
    crcExtra: 243,
    wireLength: 58,
    fields: [
      { name: "MMSI", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "INT32_MAX" },
      { name: "COG", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "UINT16_MAX" },
      { name: "heading", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "UINT16_MAX" },
      { name: "velocity", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s", invalid: "UINT16_MAX" },
      { name: "dimension_bow", type: "uint16_t", arrayLength: 0, extension: false, units: "m", invalid: "UINT16_MAX" },
      { name: "dimension_stern", type: "uint16_t", arrayLength: 0, extension: false, units: "m", invalid: "UINT16_MAX" },
      { name: "tslc", type: "uint16_t", arrayLength: 0, extension: false, units: "s" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "AIS_FLAGS" },
      { name: "turn_rate", type: "int8_t", arrayLength: 0, extension: false, units: "ddeg/s", invalid: "INT8_MAX" },
      { name: "navigational_status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "AIS_NAV_STATUS" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "AIS_TYPE" },
      { name: "dimension_port", type: "uint8_t", arrayLength: 0, extension: false, units: "m", invalid: "UINT8_MAX" },
      { name: "dimension_starboard", type: "uint8_t", arrayLength: 0, extension: false, units: "m", invalid: "UINT8_MAX" },
      { name: "callsign", type: "char", arrayLength: 7, extension: false },
      { name: "name", type: "char", arrayLength: 20, extension: false },
    ],
  },
  {
    id: 310,
    name: "UAVCAN_NODE_STATUS",
    crcExtra: 28,
    wireLength: 17,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "uptime_sec", type: "uint32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "vendor_specific_status_code", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "health", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVCAN_NODE_HEALTH" },
      { name: "mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVCAN_NODE_MODE" },
      { name: "sub_mode", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 311,
    name: "UAVCAN_NODE_INFO",
    crcExtra: 95,
    wireLength: 116,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "uptime_sec", type: "uint32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "sw_vcs_commit", type: "uint32_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "name", type: "char", arrayLength: 80, extension: false },
      { name: "hw_version_major", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "hw_version_minor", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "hw_unique_id", type: "uint8_t", arrayLength: 16, extension: false },
      { name: "sw_version_major", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "sw_version_minor", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 320,
    name: "PARAM_EXT_REQUEST_READ",
    crcExtra: 243,
    wireLength: 20,
    fields: [
      { name: "param_index", type: "int16_t", arrayLength: 0, extension: false, invalid: "-1" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
    ],
  },
  {
    id: 321,
    name: "PARAM_EXT_REQUEST_LIST",
    crcExtra: 88,
    wireLength: 2,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 322,
    name: "PARAM_EXT_VALUE",
    crcExtra: 243,
    wireLength: 149,
    fields: [
      { name: "param_count", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "param_index", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "param_value", type: "char", arrayLength: 128, extension: false },
      { name: "param_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_PARAM_EXT_TYPE" },
    ],
  },
  {
    id: 323,
    name: "PARAM_EXT_SET",
    crcExtra: 78,
    wireLength: 147,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "param_value", type: "char", arrayLength: 128, extension: false },
      { name: "param_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_PARAM_EXT_TYPE" },
    ],
  },
  {
    id: 324,
    name: "PARAM_EXT_ACK",
    crcExtra: 132,
    wireLength: 146,
    fields: [
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "param_value", type: "char", arrayLength: 128, extension: false },
      { name: "param_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_PARAM_EXT_TYPE" },
      { name: "param_result", type: "uint8_t", arrayLength: 0, extension: false, enumName: "PARAM_ACK" },
    ],
  },
  {
    id: 330,
    name: "OBSTACLE_DISTANCE",
    crcExtra: 23,
    wireLength: 167,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "distances", type: "uint16_t", arrayLength: 72, extension: false, units: "cm", invalid: "[UINT16_MAX]" },
      { name: "min_distance", type: "uint16_t", arrayLength: 0, extension: false, units: "cm" },
      { name: "max_distance", type: "uint16_t", arrayLength: 0, extension: false, units: "cm" },
      { name: "sensor_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_DISTANCE_SENSOR" },
      { name: "increment", type: "uint8_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "increment_f", type: "float", arrayLength: 0, extension: true, units: "deg" },
      { name: "angle_offset", type: "float", arrayLength: 0, extension: true, units: "deg" },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 331,
    name: "ODOMETRY",
    crcExtra: 91,
    wireLength: 233,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "q", type: "float", arrayLength: 4, extension: false },
      { name: "vx", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vy", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "vz", type: "float", arrayLength: 0, extension: false, units: "m/s" },
      { name: "rollspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pitchspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "yawspeed", type: "float", arrayLength: 0, extension: false, units: "rad/s" },
      { name: "pose_covariance", type: "float", arrayLength: 21, extension: false, invalid: "[NaN:]" },
      { name: "velocity_covariance", type: "float", arrayLength: 21, extension: false, invalid: "[NaN:]" },
      { name: "frame_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
      { name: "child_frame_id", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
      { name: "reset_counter", type: "uint8_t", arrayLength: 0, extension: true },
      { name: "estimator_type", type: "uint8_t", arrayLength: 0, extension: true, enumName: "MAV_ESTIMATOR_TYPE" },
      { name: "quality", type: "int8_t", arrayLength: 0, extension: true, units: "%", invalid: "0" },
    ],
  },
  {
    id: 332,
    name: "TRAJECTORY_REPRESENTATION_WAYPOINTS",
    crcExtra: 236,
    wireLength: 239,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "pos_x", type: "float", arrayLength: 5, extension: false, units: "m", invalid: "[NaN]" },
      { name: "pos_y", type: "float", arrayLength: 5, extension: false, units: "m", invalid: "[NaN]" },
      { name: "pos_z", type: "float", arrayLength: 5, extension: false, units: "m", invalid: "[NaN]" },
      { name: "vel_x", type: "float", arrayLength: 5, extension: false, units: "m/s", invalid: "[NaN]" },
      { name: "vel_y", type: "float", arrayLength: 5, extension: false, units: "m/s", invalid: "[NaN]" },
      { name: "vel_z", type: "float", arrayLength: 5, extension: false, units: "m/s", invalid: "[NaN]" },
      { name: "acc_x", type: "float", arrayLength: 5, extension: false, units: "m/s/s", invalid: "[NaN]" },
      { name: "acc_y", type: "float", arrayLength: 5, extension: false, units: "m/s/s", invalid: "[NaN]" },
      { name: "acc_z", type: "float", arrayLength: 5, extension: false, units: "m/s/s", invalid: "[NaN]" },
      { name: "pos_yaw", type: "float", arrayLength: 5, extension: false, units: "rad", invalid: "[NaN]" },
      { name: "vel_yaw", type: "float", arrayLength: 5, extension: false, units: "rad/s", invalid: "[NaN]" },
      { name: "command", type: "uint16_t", arrayLength: 5, extension: false, enumName: "MAV_CMD", invalid: "[UINT16_MAX]" },
      { name: "valid_points", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 333,
    name: "TRAJECTORY_REPRESENTATION_BEZIER",
    crcExtra: 231,
    wireLength: 109,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "pos_x", type: "float", arrayLength: 5, extension: false, units: "m", invalid: "[NaN]" },
      { name: "pos_y", type: "float", arrayLength: 5, extension: false, units: "m", invalid: "[NaN]" },
      { name: "pos_z", type: "float", arrayLength: 5, extension: false, units: "m", invalid: "[NaN]" },
      { name: "delta", type: "float", arrayLength: 5, extension: false, units: "s", invalid: "[NaN]" },
      { name: "pos_yaw", type: "float", arrayLength: 5, extension: false, units: "rad", invalid: "[NaN]" },
      { name: "valid_points", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 334,
    name: "CELLULAR_STATUS",
    crcExtra: 72,
    wireLength: 53,
    fields: [
      { name: "mcc", type: "uint16_t", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "mnc", type: "uint16_t", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "lac", type: "uint16_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CELLULAR_STATUS_FLAG" },
      { name: "failure_reason", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CELLULAR_NETWORK_FAILED_REASON" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CELLULAR_NETWORK_RADIO_TYPE" },
      { name: "quality", type: "uint8_t", arrayLength: 0, extension: false, invalid: "UINT8_MAX" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: true, minValue: "1" },
      { name: "link_tx_rate", type: "uint32_t", arrayLength: 0, extension: true, units: "KiB/s", invalid: "0" },
      { name: "link_rx_rate", type: "uint32_t", arrayLength: 0, extension: true, units: "KiB/s", invalid: "0" },
      { name: "cell_tower_id", type: "char", arrayLength: 9, extension: true, invalid: "0" },
      { name: "band_number", type: "uint8_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "band_frequency", type: "float", arrayLength: 0, extension: true, units: "MHz", invalid: "0" },
      { name: "channel_number", type: "uint32_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "rx_level", type: "float", arrayLength: 0, extension: true, units: "dBm", invalid: "0" },
      { name: "tx_level", type: "float", arrayLength: 0, extension: true, units: "dBm", invalid: "0" },
      { name: "rx_quality", type: "float", arrayLength: 0, extension: true, units: "dBm", invalid: "0" },
      { name: "sinr", type: "float", arrayLength: 0, extension: true, units: "dB", invalid: "0" },
    ],
  },
  {
    id: 335,
    name: "ISBD_LINK_STATUS",
    crcExtra: 225,
    wireLength: 24,
    fields: [
      { name: "timestamp", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "last_heartbeat", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "failed_sessions", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "successful_sessions", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "signal_quality", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "ring_pending", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "tx_session_pending", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "rx_session_pending", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 336,
    name: "CELLULAR_CONFIG",
    crcExtra: 245,
    wireLength: 84,
    fields: [
      { name: "enable_lte", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "enable_pin", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "pin", type: "char", arrayLength: 16, extension: false },
      { name: "new_pin", type: "char", arrayLength: 16, extension: false },
      { name: "apn", type: "char", arrayLength: 32, extension: false },
      { name: "puk", type: "char", arrayLength: 16, extension: false },
      { name: "roaming", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "response", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CELLULAR_CONFIG_RESPONSE" },
    ],
  },
  {
    id: 339,
    name: "RAW_RPM",
    crcExtra: 199,
    wireLength: 5,
    fields: [
      { name: "frequency", type: "float", arrayLength: 0, extension: false, units: "rpm" },
      { name: "index", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 340,
    name: "UTM_GLOBAL_POSITION",
    crcExtra: 99,
    wireLength: 70,
    fields: [
      { name: "time", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "relative_alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "next_lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "next_lon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "next_alt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "vx", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vy", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "vz", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "h_acc", type: "uint16_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "v_acc", type: "uint16_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "vel_acc", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "update_rate", type: "uint16_t", arrayLength: 0, extension: false, units: "cs", invalid: "0" },
      { name: "uas_id", type: "uint8_t", arrayLength: 18, extension: false },
      { name: "flight_state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UTM_FLIGHT_STATE" },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UTM_DATA_AVAIL_FLAGS" },
    ],
  },
  {
    id: 345,
    name: "PARAM_ERROR",
    crcExtra: 209,
    wireLength: 21,
    fields: [
      { name: "param_index", type: "int16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "error", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_PARAM_ERROR" },
    ],
  },
  {
    id: 350,
    name: "DEBUG_FLOAT_ARRAY",
    crcExtra: 232,
    wireLength: 252,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "array_id", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "name", type: "char", arrayLength: 10, extension: false },
      { name: "data", type: "float", arrayLength: 58, extension: true },
    ],
  },
  {
    id: 360,
    name: "ORBIT_EXECUTION_STATUS",
    crcExtra: 11,
    wireLength: 25,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "radius", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "x", type: "int32_t", arrayLength: 0, extension: false },
      { name: "y", type: "int32_t", arrayLength: 0, extension: false },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 361,
    name: "FIGURE_EIGHT_EXECUTION_STATUS",
    crcExtra: 93,
    wireLength: 33,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "major_radius", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "minor_radius", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "orientation", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "x", type: "int32_t", arrayLength: 0, extension: false },
      { name: "y", type: "int32_t", arrayLength: 0, extension: false },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 370,
    name: "SMART_BATTERY_INFO",
    crcExtra: 75,
    wireLength: 109,
    fields: [
      { name: "capacity_full_specification", type: "int32_t", arrayLength: 0, extension: false, units: "mAh", invalid: "-1" },
      { name: "capacity_full", type: "int32_t", arrayLength: 0, extension: false, units: "mAh", invalid: "-1" },
      { name: "cycle_count", type: "uint16_t", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "weight", type: "uint16_t", arrayLength: 0, extension: false, units: "g", invalid: "0" },
      { name: "discharge_minimum_voltage", type: "uint16_t", arrayLength: 0, extension: false, units: "mV", invalid: "UINT16_MAX" },
      { name: "charging_minimum_voltage", type: "uint16_t", arrayLength: 0, extension: false, units: "mV", invalid: "UINT16_MAX" },
      { name: "resting_minimum_voltage", type: "uint16_t", arrayLength: 0, extension: false, units: "mV", invalid: "UINT16_MAX" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "battery_function", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_BATTERY_FUNCTION" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_BATTERY_TYPE" },
      { name: "serial_number", type: "char", arrayLength: 16, extension: false, invalid: "[0]" },
      { name: "device_name", type: "char", arrayLength: 50, extension: false, invalid: "[0]" },
      { name: "charging_maximum_voltage", type: "uint16_t", arrayLength: 0, extension: true, units: "mV", invalid: "0" },
      { name: "cells_in_series", type: "uint8_t", arrayLength: 0, extension: true, invalid: "0" },
      { name: "discharge_maximum_current", type: "uint32_t", arrayLength: 0, extension: true, units: "mA", invalid: "0" },
      { name: "discharge_maximum_burst_current", type: "uint32_t", arrayLength: 0, extension: true, units: "mA", invalid: "0" },
      { name: "manufacture_date", type: "char", arrayLength: 11, extension: true, invalid: "[0]" },
    ],
  },
  {
    id: 371,
    name: "FUEL_STATUS",
    crcExtra: 10,
    wireLength: 26,
    fields: [
      { name: "maximum_fuel", type: "float", arrayLength: 0, extension: false },
      { name: "consumed_fuel", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "remaining_fuel", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "flow_rate", type: "float", arrayLength: 0, extension: false, invalid: "NaN" },
      { name: "temperature", type: "float", arrayLength: 0, extension: false, units: "K", invalid: "NaN" },
      { name: "fuel_type", type: "uint32_t", arrayLength: 0, extension: false, enumName: "MAV_FUEL_TYPE" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "percent_remaining", type: "uint8_t", arrayLength: 0, extension: false, units: "%", invalid: "UINT8_MAX" },
    ],
  },
  {
    id: 372,
    name: "BATTERY_INFO",
    crcExtra: 26,
    wireLength: 140,
    fields: [
      { name: "discharge_minimum_voltage", type: "float", arrayLength: 0, extension: false, units: "V", invalid: "0" },
      { name: "charging_minimum_voltage", type: "float", arrayLength: 0, extension: false, units: "V", invalid: "0" },
      { name: "resting_minimum_voltage", type: "float", arrayLength: 0, extension: false, units: "V", invalid: "0" },
      { name: "charging_maximum_voltage", type: "float", arrayLength: 0, extension: false, units: "V", invalid: "0" },
      { name: "charging_maximum_current", type: "float", arrayLength: 0, extension: false, units: "A", invalid: "0" },
      { name: "nominal_voltage", type: "float", arrayLength: 0, extension: false, units: "V", invalid: "0" },
      { name: "discharge_maximum_current", type: "float", arrayLength: 0, extension: false, units: "A", invalid: "0" },
      { name: "discharge_maximum_burst_current", type: "float", arrayLength: 0, extension: false, units: "A", invalid: "0" },
      { name: "design_capacity", type: "float", arrayLength: 0, extension: false, units: "Ah", invalid: "0" },
      { name: "full_charge_capacity", type: "float", arrayLength: 0, extension: false, units: "Ah", invalid: "NaN" },
      { name: "cycle_count", type: "uint16_t", arrayLength: 0, extension: false, invalid: "UINT16_MAX" },
      { name: "weight", type: "uint16_t", arrayLength: 0, extension: false, units: "g", invalid: "0" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "battery_function", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_BATTERY_FUNCTION" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_BATTERY_TYPE" },
      { name: "state_of_health", type: "uint8_t", arrayLength: 0, extension: false, units: "%", invalid: "UINT8_MAX" },
      { name: "cells_in_series", type: "uint8_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "manufacture_date", type: "char", arrayLength: 9, extension: false, invalid: "[0]" },
      { name: "serial_number", type: "char", arrayLength: 32, extension: false, invalid: "[0]" },
      { name: "name", type: "char", arrayLength: 50, extension: false, invalid: "[0]" },
    ],
  },
  {
    id: 373,
    name: "GENERATOR_STATUS",
    crcExtra: 117,
    wireLength: 42,
    fields: [
      { name: "status", type: "uint64_t", arrayLength: 0, extension: false, enumName: "MAV_GENERATOR_STATUS_FLAG" },
      { name: "battery_current", type: "float", arrayLength: 0, extension: false, units: "A", invalid: "NaN" },
      { name: "load_current", type: "float", arrayLength: 0, extension: false, units: "A", invalid: "NaN" },
      { name: "power_generated", type: "float", arrayLength: 0, extension: false, units: "W", invalid: "NaN" },
      { name: "bus_voltage", type: "float", arrayLength: 0, extension: false, units: "V" },
      { name: "bat_current_setpoint", type: "float", arrayLength: 0, extension: false, units: "A", invalid: "NaN" },
      { name: "runtime", type: "uint32_t", arrayLength: 0, extension: false, units: "s", invalid: "UINT32_MAX" },
      { name: "time_until_maintenance", type: "int32_t", arrayLength: 0, extension: false, units: "s", invalid: "INT32_MAX" },
      { name: "generator_speed", type: "uint16_t", arrayLength: 0, extension: false, units: "rpm", invalid: "UINT16_MAX" },
      { name: "rectifier_temperature", type: "int16_t", arrayLength: 0, extension: false, units: "degC", invalid: "INT16_MAX" },
      { name: "generator_temperature", type: "int16_t", arrayLength: 0, extension: false, units: "degC", invalid: "INT16_MAX" },
    ],
  },
  {
    id: 375,
    name: "ACTUATOR_OUTPUT_STATUS",
    crcExtra: 251,
    wireLength: 140,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "active", type: "uint32_t", arrayLength: 0, extension: false, isBitmask: true },
      { name: "actuator", type: "float", arrayLength: 32, extension: false },
    ],
  },
  {
    id: 376,
    name: "RELAY_STATUS",
    crcExtra: 199,
    wireLength: 8,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "on", type: "uint16_t", arrayLength: 0, extension: false, isBitmask: true },
      { name: "present", type: "uint16_t", arrayLength: 0, extension: false, isBitmask: true },
    ],
  },
  {
    id: 380,
    name: "TIME_ESTIMATE_TO_TARGET",
    crcExtra: 232,
    wireLength: 20,
    fields: [
      { name: "safe_return", type: "int32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "land", type: "int32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "mission_next_item", type: "int32_t", arrayLength: 0, extension: false, units: "s", invalid: "-1" },
      { name: "mission_end", type: "int32_t", arrayLength: 0, extension: false, units: "s", invalid: "-1" },
      { name: "commanded_action", type: "int32_t", arrayLength: 0, extension: false, units: "s", invalid: "-1" },
    ],
  },
  {
    id: 385,
    name: "TUNNEL",
    crcExtra: 147,
    wireLength: 133,
    fields: [
      { name: "payload_type", type: "uint16_t", arrayLength: 0, extension: false, enumName: "MAV_TUNNEL_PAYLOAD_TYPE" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "payload_length", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "payload", type: "uint8_t", arrayLength: 128, extension: false },
    ],
  },
  {
    id: 386,
    name: "CAN_FRAME",
    crcExtra: 132,
    wireLength: 16,
    fields: [
      { name: "id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "bus", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 8, extension: false },
    ],
  },
  {
    id: 387,
    name: "CANFD_FRAME",
    crcExtra: 4,
    wireLength: 72,
    fields: [
      { name: "id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "bus", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "len", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 64, extension: false },
    ],
  },
  {
    id: 388,
    name: "CAN_FILTER_MODIFY",
    crcExtra: 8,
    wireLength: 37,
    fields: [
      { name: "ids", type: "uint16_t", arrayLength: 16, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "bus", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "operation", type: "uint8_t", arrayLength: 0, extension: false, enumName: "CAN_FILTER_OP" },
      { name: "num_ids", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 390,
    name: "ONBOARD_COMPUTER_STATUS",
    crcExtra: 156,
    wireLength: 240,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "uptime", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "ram_usage", type: "uint32_t", arrayLength: 0, extension: false, units: "MiB", invalid: "UINT32_MAX" },
      { name: "ram_total", type: "uint32_t", arrayLength: 0, extension: false, units: "MiB", invalid: "UINT32_MAX" },
      { name: "storage_type", type: "uint32_t", arrayLength: 4, extension: false, invalid: "[UINT32_MAX]" },
      { name: "storage_usage", type: "uint32_t", arrayLength: 4, extension: false, units: "MiB", invalid: "[UINT32_MAX]" },
      { name: "storage_total", type: "uint32_t", arrayLength: 4, extension: false, units: "MiB", invalid: "[UINT32_MAX]" },
      { name: "link_type", type: "uint32_t", arrayLength: 6, extension: false },
      { name: "link_tx_rate", type: "uint32_t", arrayLength: 6, extension: false, units: "KiB/s", invalid: "[UINT32_MAX]" },
      { name: "link_rx_rate", type: "uint32_t", arrayLength: 6, extension: false, units: "KiB/s", invalid: "[UINT32_MAX]" },
      { name: "link_tx_max", type: "uint32_t", arrayLength: 6, extension: false, units: "KiB/s", invalid: "[UINT32_MAX]" },
      { name: "link_rx_max", type: "uint32_t", arrayLength: 6, extension: false, units: "KiB/s", invalid: "[UINT32_MAX]" },
      { name: "fan_speed", type: "int16_t", arrayLength: 4, extension: false, units: "rpm", invalid: "[INT16_MAX]" },
      { name: "type", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "cpu_cores", type: "uint8_t", arrayLength: 8, extension: false, invalid: "[UINT8_MAX]" },
      { name: "cpu_combined", type: "uint8_t", arrayLength: 10, extension: false, invalid: "[UINT8_MAX]" },
      { name: "gpu_cores", type: "uint8_t", arrayLength: 4, extension: false, invalid: "[UINT8_MAX]" },
      { name: "gpu_combined", type: "uint8_t", arrayLength: 10, extension: false, invalid: "[UINT8_MAX]" },
      { name: "temperature_board", type: "int8_t", arrayLength: 0, extension: false, units: "degC", invalid: "INT8_MAX" },
      { name: "temperature_core", type: "int8_t", arrayLength: 8, extension: false, units: "degC", invalid: "[INT8_MAX]" },
      { name: "status_flags", type: "uint16_t", arrayLength: 0, extension: true, enumName: "COMPUTER_STATUS_FLAGS" },
    ],
  },
  {
    id: 395,
    name: "COMPONENT_INFORMATION",
    crcExtra: 0,
    wireLength: 212,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "general_metadata_file_crc", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "peripherals_metadata_file_crc", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "general_metadata_uri", type: "char", arrayLength: 100, extension: false },
      { name: "peripherals_metadata_uri", type: "char", arrayLength: 100, extension: false },
    ],
  },
  {
    id: 396,
    name: "COMPONENT_INFORMATION_BASIC",
    crcExtra: 50,
    wireLength: 160,
    fields: [
      { name: "capabilities", type: "uint64_t", arrayLength: 0, extension: false, enumName: "MAV_PROTOCOL_CAPABILITY" },
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "time_manufacture_s", type: "uint32_t", arrayLength: 0, extension: false, units: "s", invalid: "0" },
      { name: "vendor_name", type: "char", arrayLength: 32, extension: false },
      { name: "model_name", type: "char", arrayLength: 32, extension: false },
      { name: "software_version", type: "char", arrayLength: 24, extension: false },
      { name: "hardware_version", type: "char", arrayLength: 24, extension: false },
      { name: "serial_number", type: "char", arrayLength: 32, extension: false },
    ],
  },
  {
    id: 397,
    name: "COMPONENT_METADATA",
    crcExtra: 182,
    wireLength: 108,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "file_crc", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "uri", type: "char", arrayLength: 100, extension: false },
    ],
  },
  {
    id: 400,
    name: "PLAY_TUNE_V2",
    crcExtra: 110,
    wireLength: 254,
    fields: [
      { name: "format", type: "uint32_t", arrayLength: 0, extension: false, enumName: "TUNE_FORMAT" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "tune", type: "char", arrayLength: 248, extension: false },
    ],
  },
  {
    id: 401,
    name: "SUPPORTED_TUNES",
    crcExtra: 183,
    wireLength: 6,
    fields: [
      { name: "format", type: "uint32_t", arrayLength: 0, extension: false, enumName: "TUNE_FORMAT" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 410,
    name: "EVENT",
    crcExtra: 160,
    wireLength: 53,
    fields: [
      { name: "id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "event_time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "destination_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "destination_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "log_levels", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "arguments", type: "uint8_t", arrayLength: 40, extension: false },
    ],
  },
  {
    id: 411,
    name: "CURRENT_EVENT_SEQUENCE",
    crcExtra: 106,
    wireLength: 3,
    fields: [
      { name: "sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "flags", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_EVENT_CURRENT_SEQUENCE_FLAGS" },
    ],
  },
  {
    id: 412,
    name: "REQUEST_EVENT",
    crcExtra: 33,
    wireLength: 6,
    fields: [
      { name: "first_sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "last_sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 413,
    name: "RESPONSE_EVENT_ERROR",
    crcExtra: 77,
    wireLength: 7,
    fields: [
      { name: "sequence", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "sequence_oldest_available", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "reason", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_EVENT_ERROR_REASON" },
    ],
  },
  {
    id: 420,
    name: "RADIO_RC_CHANNELS",
    crcExtra: 20,
    wireLength: 73,
    fields: [
      { name: "time_last_update_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "flags", type: "uint16_t", arrayLength: 0, extension: false, enumName: "RADIO_RC_CHANNELS_FLAGS" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "channels", type: "int16_t", arrayLength: 32, extension: true, minValue: "-4096", maxValue: "4096" },
    ],
  },
  {
    id: 435,
    name: "AVAILABLE_MODES",
    crcExtra: 134,
    wireLength: 47,
    fields: [
      { name: "custom_mode", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "properties", type: "uint32_t", arrayLength: 0, extension: false, enumName: "MAV_MODE_PROPERTY" },
      { name: "number_modes", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mode_index", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "standard_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_STANDARD_MODE" },
      { name: "mode_name", type: "char", arrayLength: 35, extension: false },
      { name: "seq", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 436,
    name: "CURRENT_MODE",
    crcExtra: 193,
    wireLength: 9,
    fields: [
      { name: "custom_mode", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "intended_custom_mode", type: "uint32_t", arrayLength: 0, extension: false, invalid: "0" },
      { name: "standard_mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_STANDARD_MODE" },
    ],
  },
  {
    id: 437,
    name: "AVAILABLE_MODES_MONITOR",
    crcExtra: 30,
    wireLength: 1,
    fields: [
      { name: "seq", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 440,
    name: "ILLUMINATOR_STATUS",
    crcExtra: 66,
    wireLength: 35,
    fields: [
      { name: "uptime_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "error_status", type: "uint32_t", arrayLength: 0, extension: false, enumName: "ILLUMINATOR_ERROR_FLAGS" },
      { name: "brightness", type: "float", arrayLength: 0, extension: false, units: "%" },
      { name: "strobe_period", type: "float", arrayLength: 0, extension: false, units: "s" },
      { name: "strobe_duty_cycle", type: "float", arrayLength: 0, extension: false, units: "%" },
      { name: "temp_c", type: "float", arrayLength: 0, extension: false },
      { name: "min_strobe_period", type: "float", arrayLength: 0, extension: false, units: "s" },
      { name: "max_strobe_period", type: "float", arrayLength: 0, extension: false, units: "s" },
      { name: "enable", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "mode_bitmask", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ILLUMINATOR_MODE" },
      { name: "mode", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ILLUMINATOR_MODE" },
    ],
  },
  {
    id: 9000,
    name: "WHEEL_DISTANCE",
    crcExtra: 113,
    wireLength: 137,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "distance", type: "double", arrayLength: 16, extension: false, units: "m" },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 9005,
    name: "WINCH_STATUS",
    crcExtra: 117,
    wireLength: 34,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "line_length", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "NaN" },
      { name: "speed", type: "float", arrayLength: 0, extension: false, units: "m/s", invalid: "NaN" },
      { name: "tension", type: "float", arrayLength: 0, extension: false, units: "kg", invalid: "NaN" },
      { name: "voltage", type: "float", arrayLength: 0, extension: false, units: "V", invalid: "NaN" },
      { name: "current", type: "float", arrayLength: 0, extension: false, units: "A", invalid: "NaN" },
      { name: "status", type: "uint32_t", arrayLength: 0, extension: false, enumName: "MAV_WINCH_STATUS_FLAG" },
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "degC", invalid: "INT16_MAX" },
    ],
  },
  {
    id: 10001,
    name: "UAVIONIX_ADSB_OUT_CFG",
    crcExtra: 209,
    wireLength: 20,
    fields: [
      { name: "ICAO", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "stallSpeed", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "callsign", type: "char", arrayLength: 9, extension: false },
      { name: "emitterType", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ADSB_EMITTER_TYPE" },
      { name: "aircraftSize", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE" },
      { name: "gpsOffsetLat", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT" },
      { name: "gpsOffsetLon", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON" },
      { name: "rfSelect", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_RF_SELECT" },
    ],
  },
  {
    id: 10002,
    name: "UAVIONIX_ADSB_OUT_DYNAMIC",
    crcExtra: 186,
    wireLength: 41,
    fields: [
      { name: "utcTime", type: "uint32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "gpsLat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "gpsLon", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "gpsAlt", type: "int32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "baroAltMSL", type: "int32_t", arrayLength: 0, extension: false, units: "mbar" },
      { name: "accuracyHor", type: "uint32_t", arrayLength: 0, extension: false, units: "mm" },
      { name: "accuracyVert", type: "uint16_t", arrayLength: 0, extension: false, units: "cm" },
      { name: "accuracyVel", type: "uint16_t", arrayLength: 0, extension: false, units: "mm/s" },
      { name: "velVert", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "velNS", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "VelEW", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "state", type: "uint16_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_DYNAMIC_STATE" },
      { name: "squawk", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "gpsFix", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX" },
      { name: "numSats", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "emergencyStatus", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_EMERGENCY_STATUS" },
    ],
  },
  {
    id: 10003,
    name: "UAVIONIX_ADSB_TRANSCEIVER_HEALTH_REPORT",
    crcExtra: 4,
    wireLength: 1,
    fields: [
      { name: "rfHealth", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_RF_HEALTH" },
    ],
  },
  {
    id: 10004,
    name: "UAVIONIX_ADSB_OUT_CFG_REGISTRATION",
    crcExtra: 133,
    wireLength: 9,
    fields: [
      { name: "registration", type: "char", arrayLength: 9, extension: false },
    ],
  },
  {
    id: 10005,
    name: "UAVIONIX_ADSB_OUT_CFG_FLIGHTID",
    crcExtra: 103,
    wireLength: 9,
    fields: [
      { name: "flight_id", type: "char", arrayLength: 9, extension: false },
    ],
  },
  {
    id: 10006,
    name: "UAVIONIX_ADSB_GET",
    crcExtra: 193,
    wireLength: 4,
    fields: [
      { name: "ReqMessageId", type: "uint32_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 10007,
    name: "UAVIONIX_ADSB_OUT_CONTROL",
    crcExtra: 71,
    wireLength: 17,
    fields: [
      { name: "baroAltMSL", type: "int32_t", arrayLength: 0, extension: false, units: "mbar" },
      { name: "squawk", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_CONTROL_STATE" },
      { name: "emergencyStatus", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_EMERGENCY_STATUS" },
      { name: "flight_id", type: "char", arrayLength: 8, extension: false },
      { name: "x_bit", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_XBIT" },
    ],
  },
  {
    id: 10008,
    name: "UAVIONIX_ADSB_OUT_STATUS",
    crcExtra: 240,
    wireLength: 14,
    fields: [
      { name: "squawk", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "state", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_STATUS_STATE" },
      { name: "NIC_NACp", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_STATUS_NIC_NACP" },
      { name: "boardTemp", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "fault", type: "uint8_t", arrayLength: 0, extension: false, enumName: "UAVIONIX_ADSB_OUT_STATUS_FAULT" },
      { name: "flight_id", type: "char", arrayLength: 8, extension: false },
    ],
  },
  {
    id: 10151,
    name: "LOWEHEISER_GOV_EFI",
    crcExtra: 195,
    wireLength: 85,
    fields: [
      { name: "volt_batt", type: "float", arrayLength: 0, extension: false, units: "V" },
      { name: "curr_batt", type: "float", arrayLength: 0, extension: false, units: "A" },
      { name: "curr_gen", type: "float", arrayLength: 0, extension: false, units: "A" },
      { name: "curr_rot", type: "float", arrayLength: 0, extension: false, units: "A" },
      { name: "fuel_level", type: "float", arrayLength: 0, extension: false, units: "l" },
      { name: "throttle", type: "float", arrayLength: 0, extension: false, units: "%" },
      { name: "runtime", type: "uint32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "until_maintenance", type: "int32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "rectifier_temp", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "generator_temp", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "efi_batt", type: "float", arrayLength: 0, extension: false, units: "V" },
      { name: "efi_rpm", type: "float", arrayLength: 0, extension: false, units: "rpm" },
      { name: "efi_pw", type: "float", arrayLength: 0, extension: false, units: "ms" },
      { name: "efi_fuel_flow", type: "float", arrayLength: 0, extension: false },
      { name: "efi_fuel_consumed", type: "float", arrayLength: 0, extension: false, units: "l" },
      { name: "efi_baro", type: "float", arrayLength: 0, extension: false, units: "kPa" },
      { name: "efi_mat", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "efi_clt", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "efi_tps", type: "float", arrayLength: 0, extension: false, units: "%" },
      { name: "efi_exhaust_gas_temperature", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "generator_status", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "efi_status", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "efi_index", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 11000,
    name: "DEVICE_OP_READ",
    crcExtra: 134,
    wireLength: 52,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "bustype", type: "uint8_t", arrayLength: 0, extension: false, enumName: "DEVICE_OP_BUSTYPE" },
      { name: "bus", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "address", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "busname", type: "char", arrayLength: 40, extension: false },
      { name: "regstart", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "bank", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 11001,
    name: "DEVICE_OP_READ_REPLY",
    crcExtra: 15,
    wireLength: 136,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "result", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "regstart", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 128, extension: false },
      { name: "bank", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 11002,
    name: "DEVICE_OP_WRITE",
    crcExtra: 234,
    wireLength: 180,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "bustype", type: "uint8_t", arrayLength: 0, extension: false, enumName: "DEVICE_OP_BUSTYPE" },
      { name: "bus", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "address", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "busname", type: "char", arrayLength: 40, extension: false },
      { name: "regstart", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "count", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 128, extension: false },
      { name: "bank", type: "uint8_t", arrayLength: 0, extension: true },
    ],
  },
  {
    id: 11003,
    name: "DEVICE_OP_WRITE_REPLY",
    crcExtra: 64,
    wireLength: 5,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "result", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 11004,
    name: "SECURE_COMMAND",
    crcExtra: 11,
    wireLength: 232,
    fields: [
      { name: "sequence", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "operation", type: "uint32_t", arrayLength: 0, extension: false, enumName: "SECURE_COMMAND_OP" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data_length", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "sig_length", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 220, extension: false },
    ],
  },
  {
    id: 11005,
    name: "SECURE_COMMAND_REPLY",
    crcExtra: 93,
    wireLength: 230,
    fields: [
      { name: "sequence", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "operation", type: "uint32_t", arrayLength: 0, extension: false, enumName: "SECURE_COMMAND_OP" },
      { name: "result", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_RESULT" },
      { name: "data_length", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "data", type: "uint8_t", arrayLength: 220, extension: false },
    ],
  },
  {
    id: 11010,
    name: "ADAP_TUNING",
    crcExtra: 46,
    wireLength: 49,
    fields: [
      { name: "desired", type: "float", arrayLength: 0, extension: false, units: "deg/s" },
      { name: "achieved", type: "float", arrayLength: 0, extension: false, units: "deg/s" },
      { name: "error", type: "float", arrayLength: 0, extension: false },
      { name: "theta", type: "float", arrayLength: 0, extension: false },
      { name: "omega", type: "float", arrayLength: 0, extension: false },
      { name: "sigma", type: "float", arrayLength: 0, extension: false },
      { name: "theta_dot", type: "float", arrayLength: 0, extension: false },
      { name: "omega_dot", type: "float", arrayLength: 0, extension: false },
      { name: "sigma_dot", type: "float", arrayLength: 0, extension: false },
      { name: "f", type: "float", arrayLength: 0, extension: false },
      { name: "f_dot", type: "float", arrayLength: 0, extension: false },
      { name: "u", type: "float", arrayLength: 0, extension: false },
      { name: "axis", type: "uint8_t", arrayLength: 0, extension: false, enumName: "PID_TUNING_AXIS" },
    ],
  },
  {
    id: 11011,
    name: "VISION_POSITION_DELTA",
    crcExtra: 106,
    wireLength: 44,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "time_delta_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "angle_delta", type: "float", arrayLength: 3, extension: false, units: "rad" },
      { name: "position_delta", type: "float", arrayLength: 3, extension: false, units: "m" },
      { name: "confidence", type: "float", arrayLength: 0, extension: false, units: "%" },
    ],
  },
  {
    id: 11020,
    name: "AOA_SSA",
    crcExtra: 205,
    wireLength: 16,
    fields: [
      { name: "time_usec", type: "uint64_t", arrayLength: 0, extension: false, units: "us" },
      { name: "AOA", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "SSA", type: "float", arrayLength: 0, extension: false, units: "deg" },
    ],
  },
  {
    id: 11030,
    name: "ESC_TELEMETRY_1_TO_4",
    crcExtra: 144,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11031,
    name: "ESC_TELEMETRY_5_TO_8",
    crcExtra: 133,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11032,
    name: "ESC_TELEMETRY_9_TO_12",
    crcExtra: 85,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11033,
    name: "OSD_PARAM_CONFIG",
    crcExtra: 195,
    wireLength: 37,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "min_value", type: "float", arrayLength: 0, extension: false },
      { name: "max_value", type: "float", arrayLength: 0, extension: false },
      { name: "increment", type: "float", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "osd_screen", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "osd_index", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "config_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "OSD_PARAM_CONFIG_TYPE" },
    ],
  },
  {
    id: 11034,
    name: "OSD_PARAM_CONFIG_REPLY",
    crcExtra: 79,
    wireLength: 5,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "result", type: "uint8_t", arrayLength: 0, extension: false, enumName: "OSD_PARAM_CONFIG_ERROR" },
    ],
  },
  {
    id: 11035,
    name: "OSD_PARAM_SHOW_CONFIG",
    crcExtra: 128,
    wireLength: 8,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "osd_screen", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "osd_index", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 11036,
    name: "OSD_PARAM_SHOW_CONFIG_REPLY",
    crcExtra: 177,
    wireLength: 34,
    fields: [
      { name: "request_id", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "min_value", type: "float", arrayLength: 0, extension: false },
      { name: "max_value", type: "float", arrayLength: 0, extension: false },
      { name: "increment", type: "float", arrayLength: 0, extension: false },
      { name: "result", type: "uint8_t", arrayLength: 0, extension: false, enumName: "OSD_PARAM_CONFIG_ERROR" },
      { name: "param_id", type: "char", arrayLength: 16, extension: false },
      { name: "config_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "OSD_PARAM_CONFIG_TYPE" },
    ],
  },
  {
    id: 11037,
    name: "OBSTACLE_DISTANCE_3D",
    crcExtra: 130,
    wireLength: 28,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "x", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "y", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "z", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "min_distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "max_distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "obstacle_id", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "sensor_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_DISTANCE_SENSOR" },
      { name: "frame", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_FRAME" },
    ],
  },
  {
    id: 11038,
    name: "WATER_DEPTH",
    crcExtra: 47,
    wireLength: 38,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "lat", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "lng", type: "int32_t", arrayLength: 0, extension: false, units: "degE7" },
      { name: "alt", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "roll", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "pitch", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "yaw", type: "float", arrayLength: 0, extension: false, units: "rad" },
      { name: "distance", type: "float", arrayLength: 0, extension: false, units: "m" },
      { name: "temperature", type: "float", arrayLength: 0, extension: false, units: "degC" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "healthy", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 11039,
    name: "MCU_STATUS",
    crcExtra: 142,
    wireLength: 9,
    fields: [
      { name: "MCU_temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC" },
      { name: "MCU_voltage", type: "uint16_t", arrayLength: 0, extension: false, units: "mV" },
      { name: "MCU_voltage_min", type: "uint16_t", arrayLength: 0, extension: false, units: "mV" },
      { name: "MCU_voltage_max", type: "uint16_t", arrayLength: 0, extension: false, units: "mV" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 11040,
    name: "ESC_TELEMETRY_13_TO_16",
    crcExtra: 132,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11041,
    name: "ESC_TELEMETRY_17_TO_20",
    crcExtra: 208,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11042,
    name: "ESC_TELEMETRY_21_TO_24",
    crcExtra: 201,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11043,
    name: "ESC_TELEMETRY_25_TO_28",
    crcExtra: 193,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11044,
    name: "ESC_TELEMETRY_29_TO_32",
    crcExtra: 189,
    wireLength: 44,
    fields: [
      { name: "voltage", type: "uint16_t", arrayLength: 4, extension: false, units: "cV" },
      { name: "current", type: "uint16_t", arrayLength: 4, extension: false, units: "cA" },
      { name: "totalcurrent", type: "uint16_t", arrayLength: 4, extension: false, units: "mAh" },
      { name: "rpm", type: "uint16_t", arrayLength: 4, extension: false, units: "rpm" },
      { name: "count", type: "uint16_t", arrayLength: 4, extension: false },
      { name: "temperature", type: "uint8_t", arrayLength: 4, extension: false, units: "degC" },
    ],
  },
  {
    id: 11060,
    name: "NAMED_VALUE_STRING",
    crcExtra: 162,
    wireLength: 78,
    fields: [
      { name: "time_boot_ms", type: "uint32_t", arrayLength: 0, extension: false, units: "ms" },
      { name: "name", type: "char", arrayLength: 10, extension: false },
      { name: "value", type: "char", arrayLength: 64, extension: false },
    ],
  },
  {
    id: 12900,
    name: "OPEN_DRONE_ID_BASIC_ID",
    crcExtra: 114,
    wireLength: 44,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "id_or_mac", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "id_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_ID_TYPE" },
      { name: "ua_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_UA_TYPE" },
      { name: "uas_id", type: "uint8_t", arrayLength: 20, extension: false },
    ],
  },
  {
    id: 12901,
    name: "OPEN_DRONE_ID_LOCATION",
    crcExtra: 254,
    wireLength: 59,
    fields: [
      { name: "latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "0" },
      { name: "longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "0" },
      { name: "altitude_barometric", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1000" },
      { name: "altitude_geodetic", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1000" },
      { name: "height", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1000" },
      { name: "timestamp", type: "float", arrayLength: 0, extension: false, units: "s", invalid: "0xFFFF" },
      { name: "direction", type: "uint16_t", arrayLength: 0, extension: false, units: "cdeg", invalid: "36100" },
      { name: "speed_horizontal", type: "uint16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "speed_vertical", type: "int16_t", arrayLength: 0, extension: false, units: "cm/s" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "id_or_mac", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_STATUS" },
      { name: "height_reference", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_HEIGHT_REF" },
      { name: "horizontal_accuracy", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_HOR_ACC" },
      { name: "vertical_accuracy", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_VER_ACC" },
      { name: "barometer_accuracy", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_VER_ACC" },
      { name: "speed_accuracy", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_SPEED_ACC" },
      { name: "timestamp_accuracy", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_TIME_ACC" },
    ],
  },
  {
    id: 12902,
    name: "OPEN_DRONE_ID_AUTHENTICATION",
    crcExtra: 140,
    wireLength: 53,
    fields: [
      { name: "timestamp", type: "uint32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "id_or_mac", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "authentication_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_AUTH_TYPE" },
      { name: "data_page", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "last_page_index", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "length", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "authentication_data", type: "uint8_t", arrayLength: 23, extension: false },
    ],
  },
  {
    id: 12903,
    name: "OPEN_DRONE_ID_SELF_ID",
    crcExtra: 249,
    wireLength: 46,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "id_or_mac", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "description_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_DESC_TYPE" },
      { name: "description", type: "char", arrayLength: 23, extension: false },
    ],
  },
  {
    id: 12904,
    name: "OPEN_DRONE_ID_SYSTEM",
    crcExtra: 77,
    wireLength: 54,
    fields: [
      { name: "operator_latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "0" },
      { name: "operator_longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "0" },
      { name: "area_ceiling", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1000" },
      { name: "area_floor", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1000" },
      { name: "operator_altitude_geo", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1000" },
      { name: "timestamp", type: "uint32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "area_count", type: "uint16_t", arrayLength: 0, extension: false },
      { name: "area_radius", type: "uint16_t", arrayLength: 0, extension: false, units: "m" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "id_or_mac", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "operator_location_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_OPERATOR_LOCATION_TYPE" },
      { name: "classification_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_CLASSIFICATION_TYPE" },
      { name: "category_eu", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_CATEGORY_EU" },
      { name: "class_eu", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_CLASS_EU" },
    ],
  },
  {
    id: 12905,
    name: "OPEN_DRONE_ID_OPERATOR_ID",
    crcExtra: 49,
    wireLength: 43,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "id_or_mac", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "operator_id_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_OPERATOR_ID_TYPE" },
      { name: "operator_id", type: "char", arrayLength: 20, extension: false },
    ],
  },
  {
    id: 12915,
    name: "OPEN_DRONE_ID_MESSAGE_PACK",
    crcExtra: 94,
    wireLength: 249,
    fields: [
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "id_or_mac", type: "uint8_t", arrayLength: 20, extension: false },
      { name: "single_message_size", type: "uint8_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "msg_pack_size", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "messages", type: "uint8_t", arrayLength: 225, extension: false },
    ],
  },
  {
    id: 12918,
    name: "OPEN_DRONE_ID_ARM_STATUS",
    crcExtra: 139,
    wireLength: 51,
    fields: [
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "MAV_ODID_ARM_STATUS" },
      { name: "error", type: "char", arrayLength: 50, extension: false },
    ],
  },
  {
    id: 12919,
    name: "OPEN_DRONE_ID_SYSTEM_UPDATE",
    crcExtra: 7,
    wireLength: 18,
    fields: [
      { name: "operator_latitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "0" },
      { name: "operator_longitude", type: "int32_t", arrayLength: 0, extension: false, units: "degE7", invalid: "0" },
      { name: "operator_altitude_geo", type: "float", arrayLength: 0, extension: false, units: "m", invalid: "-1000" },
      { name: "timestamp", type: "uint32_t", arrayLength: 0, extension: false, units: "s" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 12920,
    name: "HYGROMETER_SENSOR",
    crcExtra: 20,
    wireLength: 5,
    fields: [
      { name: "temperature", type: "int16_t", arrayLength: 0, extension: false, units: "cdegC" },
      { name: "humidity", type: "uint16_t", arrayLength: 0, extension: false, units: "c%" },
      { name: "id", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 42000,
    name: "ICAROUS_HEARTBEAT",
    crcExtra: 227,
    wireLength: 1,
    fields: [
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ICAROUS_FMS_STATE" },
    ],
  },
  {
    id: 42001,
    name: "ICAROUS_KINEMATIC_BANDS",
    crcExtra: 239,
    wireLength: 46,
    fields: [
      { name: "min1", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "max1", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "min2", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "max2", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "min3", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "max3", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "min4", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "max4", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "min5", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "max5", type: "float", arrayLength: 0, extension: false, units: "deg" },
      { name: "numBands", type: "int8_t", arrayLength: 0, extension: false },
      { name: "type1", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ICAROUS_TRACK_BAND_TYPES" },
      { name: "type2", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ICAROUS_TRACK_BAND_TYPES" },
      { name: "type3", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ICAROUS_TRACK_BAND_TYPES" },
      { name: "type4", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ICAROUS_TRACK_BAND_TYPES" },
      { name: "type5", type: "uint8_t", arrayLength: 0, extension: false, enumName: "ICAROUS_TRACK_BAND_TYPES" },
    ],
  },
  {
    id: 50001,
    name: "CUBEPILOT_RAW_RC",
    crcExtra: 246,
    wireLength: 32,
    fields: [
      { name: "rc_raw", type: "uint8_t", arrayLength: 32, extension: false },
    ],
  },
  {
    id: 50002,
    name: "HERELINK_VIDEO_STREAM_INFORMATION",
    crcExtra: 181,
    wireLength: 246,
    fields: [
      { name: "framerate", type: "float", arrayLength: 0, extension: false, units: "Hz" },
      { name: "bitrate", type: "uint32_t", arrayLength: 0, extension: false, units: "bits/s" },
      { name: "resolution_h", type: "uint16_t", arrayLength: 0, extension: false, units: "pix" },
      { name: "resolution_v", type: "uint16_t", arrayLength: 0, extension: false, units: "pix" },
      { name: "rotation", type: "uint16_t", arrayLength: 0, extension: false, units: "deg" },
      { name: "camera_id", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "status", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "uri", type: "char", arrayLength: 230, extension: false },
    ],
  },
  {
    id: 50003,
    name: "HERELINK_TELEM",
    crcExtra: 62,
    wireLength: 19,
    fields: [
      { name: "rf_freq", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "link_bw", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "link_rate", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "snr", type: "int16_t", arrayLength: 0, extension: false },
      { name: "cpu_temp", type: "int16_t", arrayLength: 0, extension: false },
      { name: "board_temp", type: "int16_t", arrayLength: 0, extension: false },
      { name: "rssi", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 50004,
    name: "CUBEPILOT_FIRMWARE_UPDATE_START",
    crcExtra: 240,
    wireLength: 10,
    fields: [
      { name: "size", type: "uint32_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "crc", type: "uint32_t", arrayLength: 0, extension: false },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 50005,
    name: "CUBEPILOT_FIRMWARE_UPDATE_RESP",
    crcExtra: 152,
    wireLength: 6,
    fields: [
      { name: "offset", type: "uint32_t", arrayLength: 0, extension: false, units: "bytes" },
      { name: "target_system", type: "uint8_t", arrayLength: 0, extension: false },
      { name: "target_component", type: "uint8_t", arrayLength: 0, extension: false },
    ],
  },
  {
    id: 52000,
    name: "AIRLINK_AUTH",
    crcExtra: 13,
    wireLength: 100,
    fields: [
      { name: "login", type: "char", arrayLength: 50, extension: false },
      { name: "password", type: "char", arrayLength: 50, extension: false },
    ],
  },
  {
    id: 52001,
    name: "AIRLINK_AUTH_RESPONSE",
    crcExtra: 239,
    wireLength: 1,
    fields: [
      { name: "resp_type", type: "uint8_t", arrayLength: 0, extension: false, enumName: "AIRLINK_AUTH_RESPONSE_TYPE" },
    ],
  },
];
